// import React, { useEffect, useState } from 'react';
import { LEAGUES, LEAGUES_CATEGORIZED, MARKETS, SPORTS, SPORTSBOOKS, getWagerWizDisplayOptions, convertWagerWizSelectionToBackend, convertBackendToWagerWizDisplay, getSharpBooksDisplayCount } from '../../../utils/constants';
import { getSportsbookDisplayName } from '../../../utils/sportsbookAliases';
import React, { useEffect, useLayoutEffect, useState, useMemo, useRef } from 'react';
// import { LEAGUES, LEAGUES_CATEGORIZED, MARKETS, SPORTS, SPORTSBOOKS, getWagerWizDisplayOptions, convertWagerWizSelectionToBackend, convertBackendToWagerWizDisplay } from '../../../utils/constants';
import { LEAGUE_SPORT_MAP } from '../../screener/leagueToSportMapping';
import checked_checkbox from '../../../assets/images/checked_checkbox.svg';
import unchecked_checkbox from '../../../assets/images/unchecked_checkbox.svg';
import magnifying_glass from '../../../assets/images/magnifying_glass.svg';
import { Modal, Popover, Table, TableBody, TableCell, TableHead, TableRow, Tooltip } from '@mui/material';
import axios from 'axios';
import { RenameQuery } from '../EVScreen/RenameQuery';
import { FiltersContainer } from './FiltersContainer';
import { CustomAutoCompleteFilter } from './CustomAutocompleteFilter';
import { IOSSwitch } from '../../../components/IOSSwitch';
import { MinMaxEvComponent } from './MinMaxEv';
import { MinMaxOddsComponent } from './MinMaxOdds';
import { DatePickerComponent } from './Datepicker';
import edit_icon from '../../../assets/images/edit_icon.svg';
import play_icon from '../../../assets/images/play_icon.svg';
import eye_icon from '../../../assets/images/eye_icon.svg';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { BasicFiltersComponent } from './BasicFiltersComponent';
import { AdvancedFiltersComponent } from './AdvancedFiltersComponent';
import { createPortal } from 'react-dom';
import { LogoGenerator } from '../../../components/LogoGenerator';
import { saveUserInfo } from '../../../utils/api/saveUserInfo';
import EditIcon from '@mui/icons-material/Edit';
import CustomNumberInput from './CustomNumberInput';
import { EvPercentKeypad } from './EvPercentKeypad';
import { OddsKeypad } from './OddsKeypad';
import { LimitKeypad } from './LimitKeypad';

const propertyToTitleMapping = {
	sportsbooks: 'Sportsbooks',
	sharpBooks: 'Sharp Books',
	sports: 'Sports',
	leagues: 'Leagues',
	markets: 'Markets',
	marketTypes: 'Market Types',
	minMaxEv: 'Min/Max EV%',
	minMaxOdds: 'Min/Max Odds',
	limit: 'Sharp Book Limit',
	hide_alternates: 'Hide Alternate Lines',
	date: 'Date Range',
	name: 'Filter Name',
};

// Helper function to categorize markets by Type and Time (same as desktop version)
const categorizeMarkets = (markets) => {
	const categorized = {};
	const seen = new Set(); // Track unique markets
	
	markets.forEach(market => {
		// Skip duplicates
		if (seen.has(market)) return;
		seen.add(market);
		
		// Determine Type
		let type = 'Other';
		const marketLower = market.toLowerCase();
		
		if (marketLower.includes('player') || marketLower.includes('fantasy score') || marketLower.includes('scorer') || 
			marketLower.includes('batsman') || marketLower.includes('bowler') || marketLower.includes('man of the match') ||
			marketLower.includes('first goal scorer') || marketLower.includes('last goal scorer') || 
			marketLower.includes('second goal scorer') || marketLower.includes('third goal scorer') ||
			marketLower.includes('first touchdown scorer') || marketLower.includes('last touchdown scorer') ||
			marketLower.includes('first basket') || marketLower.includes('first try scorer') ||
			marketLower.includes('first card receiver') || marketLower.includes('anytime card receiver') ||
			marketLower.includes('anytime red card receiver') || marketLower.includes('first card') ||
			marketLower.includes('player assists') || marketLower.includes('player goals') ||
			marketLower.includes('player points') || marketLower.includes('player rebounds') ||
			marketLower.includes('player saves') || marketLower.includes('player shots') ||
			marketLower.includes('player passes') || marketLower.includes('player tackles') ||
			marketLower.includes('player blocks') || marketLower.includes('player steals') ||
			marketLower.includes('player runs') || marketLower.includes('player hits') ||
			marketLower.includes('player strikeouts') || marketLower.includes('player aces') ||
			marketLower.includes('player cards') || marketLower.includes('player fouls') ||
			marketLower.includes('player interceptions') || marketLower.includes('player sacks') ||
			marketLower.includes('player touchdowns') || marketLower.includes('player yards') ||
			marketLower.includes('player fantasy')) {
			type = 'Player Prop';
		} else if (marketLower.includes('moneyline') || marketLower.includes('draw no bet')) {
			type = 'Moneyline';
		} else if (marketLower.includes('spread') || marketLower.includes('handicap') || marketLower.includes('puck line') || 
			marketLower.includes('run line') || marketLower.includes('point spread') || marketLower.includes('goal spread') ||
			marketLower.includes('asian handicap') || marketLower.includes('game spread') || 
			marketLower.includes('set handicap') || marketLower.includes('round handicap') ||
			marketLower.includes('map handicap') || marketLower.includes('kills handicap') ||
			marketLower.includes('aces handicap') || marketLower.includes('cards handicap') ||
			marketLower.includes('corners handicap')) {
			type = 'Spread';
		} else if (marketLower.includes('total') || marketLower.includes('over/under') || marketLower.includes('odd/even')) {
			type = 'Total';
		} else if (marketLower.includes('team total') || marketLower.includes('team to score') || 
			marketLower.includes('team to win') || marketLower.includes('team clean sheet') ||
			marketLower.includes('first team to score') || marketLower.includes('last team to score') ||
			marketLower.includes('team highest') || marketLower.includes('team with most') ||
			marketLower.includes('team top')) {
			type = 'Team';
		} else if (marketLower.includes('race to')) {
			type = 'Race To';
		} else {
			type = 'Other';
		}
		
		// Determine Time - Group innings, maps, and sets together
		let time = 'Game';
		
		// Check for innings first (group all innings under "Inning")
		if (marketLower.includes('inning') || marketLower.includes('innings')) {
			time = 'Inning';
		} 
		// Check for sets (group all sets under "Set")
		else if (/[0-9]+(st|nd|rd|th)\s+set/i.test(marketLower) || 
			(marketLower.includes('set') && !marketLower.includes('handicap') && !marketLower.includes('set handicap') &&
			 (marketLower.includes('1st set') || marketLower.includes('2nd set') || 
			  marketLower.includes('3rd set') || marketLower.includes('4th set') || 
			  marketLower.includes('5th set')))) {
			time = 'Set';
		}
		// Check for maps (group all maps under "Map")
		else if (/[0-9]+(st|nd|rd|th)\s+([0-9]+\s+)?maps?/i.test(marketLower) || 
			(marketLower.includes('map') && !marketLower.includes('handicap') && !marketLower.includes('map handicap') &&
			 (marketLower.includes('1st map') || marketLower.includes('2nd map') || 
			  marketLower.includes('3rd map') || marketLower.includes('4th map') || 
			  marketLower.includes('5th map') || marketLower.includes('1st 2 maps') ||
			  marketLower.includes('1st 3 maps') || marketLower.includes('1st 4 maps') ||
			  marketLower.includes('maps player') || /[0-9]+(st|nd|rd|th)\s+[0-9]+\s+maps/i.test(marketLower)))) {
			time = 'Map';
		}
		// Check for other time periods
		else if (marketLower.includes('1st half') || marketLower.includes('1st quarter') || 
			marketLower.includes('1st period') ||
			marketLower.includes('1st 10 minutes') || marketLower.includes('1st 5 minutes') ||
			marketLower.includes('1st 3 quarters') ||
			marketLower.includes('1st round') || marketLower.includes('1st 3 holes') ||
			marketLower.includes('1st x overs')) {
			if (marketLower.includes('1st half')) time = '1st Half';
			else if (marketLower.includes('1st quarter')) time = '1st Quarter';
			else if (marketLower.includes('1st period')) time = '1st Period';
			else if (marketLower.includes('1st 10 minutes')) time = '1st 10 Mins';
			else if (marketLower.includes('1st 5 minutes')) time = '1st 5 Mins';
			else if (marketLower.includes('1st 3 quarters')) time = '1st 3 Quarter';
			else if (marketLower.includes('1st round')) time = '1st Round';
			else if (marketLower.includes('1st 3 holes')) time = '1st 3 Holes';
			else if (marketLower.includes('1st x overs')) time = '1st X Overs';
			else time = '1st Half';
		} else if (marketLower.includes('2nd half') || marketLower.includes('2nd quarter') || 
			marketLower.includes('2nd period') ||
			marketLower.includes('2nd round')) {
			if (marketLower.includes('2nd half')) time = '2nd Half';
			else if (marketLower.includes('2nd quarter')) time = '2nd Quarter';
			else if (marketLower.includes('2nd period')) time = '2nd Period';
			else if (marketLower.includes('2nd round')) time = '2nd Round';
			else time = '2nd Half';
		} else if (marketLower.includes('3rd quarter') || marketLower.includes('3rd period')) {
			if (marketLower.includes('3rd quarter')) time = '3rd Quarter';
			else if (marketLower.includes('3rd period')) time = '3rd Period';
			else time = '3rd Quarter';
		} else if (marketLower.includes('4th quarter')) {
			time = '4th Quarter';
		} else if (marketLower.includes('reg time') || marketLower.includes('no ot') || marketLower.includes('(no ot)')) {
			// Group "Game (No OT)" with "Game"
			time = 'Game';
		} else if (marketLower.includes('single over') || marketLower.includes('1st over') || 
			marketLower.includes('2nd over') || marketLower.includes('over team total')) {
			time = 'Single Over';
		} else if (marketLower.includes('1st 3 quarter')) {
			time = '1st 3 Quarter';
		} else if (marketLower.includes('golf')) {
			time = 'Golf';
		} else {
			time = 'Game';
		}
		
		// Add to categorized structure
		if (!categorized[type]) {
			categorized[type] = {};
		}
		if (!categorized[type][time]) {
			categorized[type][time] = [];
		}
		categorized[type][time].push({ label: market, value: market });
	});
	
	return categorized;
};

// Hide Alternates Filter Content Component
const HideAlternatesContent = ({ filters, activeRowIdx, setFilters, email, onClose }) => {
	const isChecked = !!filters[activeRowIdx]?.hide_alternates;

	const handleToggle = async () => {
		const copy = JSON.parse(JSON.stringify(filters));
		copy[activeRowIdx].hide_alternates = !isChecked;
		setFilters(copy);
		const userdb = JSON.parse(window.localStorage.getItem('userdb') || 'null');
		const selectedName = userdb?.selected_query || (userdb?.queries?.[0]?.[0]?.name ?? 'default');
		const idx = userdb?.queries.findIndex(q => q?.[0]?.name === selectedName);
		if (idx !== -1) {
			if (userdb?.queries) userdb.queries[idx] = copy;
			window.localStorage.setItem('userdb', JSON.stringify(userdb));
			await saveUserInfo(copy, email, false);
		}
	};

	return createPortal(
		<div style={{zIndex: 10000}} className="bg-gray-900 text-white fixed top-0 left-0 w-full h-full p-4 flex flex-col">
			<div className="flex items-center justify-between mb-6">
				<div className="flex items-center gap-3">
					{onClose && (
						<button
							className="flex items-center justify-center w-10 h-10 rounded-xl bg-gray-800/80 border border-gray-600 hover:bg-gray-700 hover:border-gray-500 transition-all duration-200 backdrop-blur-sm"
							aria-label="Back"
							onClick={onClose}
						>
							<svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
								<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
							</svg>
						</button>
					)}
					<div>
						<h2 className="text-xl font-bold text-white">Hide Alternate Lines</h2>
					</div>
				</div>
				<button 
					onClick={onClose} 
					className="flex items-center justify-center w-10 h-10 rounded-xl bg-gray-800/80 border border-gray-600 hover:bg-gray-700 hover:border-gray-500 transition-all duration-200 backdrop-blur-sm"
					aria-label="Close"
				>
					<svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
						<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
					</svg>
				</button>
			</div>
			
			<div className="flex-1 overflow-y-auto flex items-center justify-center">
				<div className="w-full max-w-md space-y-6">
					{/* Description */}
					<div className="space-y-3 text-center">
						<p className="text-base text-gray-400">
							Hide alternate betting lines and only show primary/featured lines.
						</p>
					</div>
					
					{/* Toggle Switch */}
					<div className="flex flex-col items-center gap-4">
						<button
							onClick={handleToggle}
							className={`relative inline-flex items-center rounded-full transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-gray-900 ${
								isChecked ? 'bg-blue-600' : 'bg-gray-700'
							}`}
							style={{
								width: '72px',
								height: '40px',
							}}
							role="switch"
							aria-checked={isChecked}
							aria-label="Hide Alternate Lines"
						>
							<span
								className={`inline-block rounded-full bg-white shadow-lg transform transition-transform duration-300 ${
									isChecked ? 'translate-x-8' : 'translate-x-1'
								}`}
								style={{
									width: '32px',
									height: '32px',
								}}
							/>
						</button>
						
						<div className="flex items-center gap-3">
							<span className={`text-lg font-semibold ${isChecked ? 'text-blue-400' : 'text-gray-400'}`}>
								{isChecked ? 'Enabled' : 'Disabled'}
							</span>
						</div>
					</div>
					
					{/* Additional Info */}
					<div className="mt-8 pt-6 border-t border-gray-700">
						<p className="text-sm text-gray-500 leading-relaxed text-center">
							Alternate lines include spreads, totals, or prop variations that differ from the most likely outcomes. Hiding alt lines can help you focus on more liquid markets and delay being profiled as a winning player.
						</p>
					</div>
				</div>
			</div>
		</div>,
		document.body
	);
};

// Limit Filter Content Component - Integrated keypad without modal overlay
const LimitFilterContent = ({ filters, activeRowIdx, setFilters, email, onClose }) => {
	const [input, setInput] = useState((filters[activeRowIdx]?.limit || 0).toString());

	useEffect(() => {
		setInput((filters[activeRowIdx]?.limit || 0).toString());
	}, [filters, activeRowIdx]);

	const handleKey = (num) => {
		if (input.length >= 7) return; // Allow for up to 7 digits (millions)
		if (input === '0') {
			setInput(num);
		} else {
			setInput(input + num);
		}
	};

	const handleBackspace = () => {
		if (input.length === 1) {
			setInput('0');
		} else {
			setInput(input.slice(0, -1));
		}
	};

	const handleSubmit = async () => {
		const val = parseInt(input, 10);
		if (!isNaN(val) && val >= 0) {
			const copy = JSON.parse(JSON.stringify(filters));
			copy[activeRowIdx].limit = val;
			setFilters(copy);
			const userdb = JSON.parse(window.localStorage.getItem('userdb') || 'null');
			const selectedName = userdb?.selected_query || (userdb?.queries?.[0]?.[0]?.name ?? 'default');
			const idx = userdb?.queries.findIndex(q => q?.[0]?.name === selectedName);
			if (idx !== -1) {
				if (userdb?.queries) userdb.queries[idx] = copy;
				window.localStorage.setItem('userdb', JSON.stringify(userdb));
				await saveUserInfo(copy, email, false);
			}
		}
	};

	return createPortal(
		<div style={{zIndex: 10000}} className="bg-gray-900 text-white fixed top-0 left-0 w-full h-full p-4 flex flex-col">
			<div className="flex items-center justify-between mb-6">
				<div className="flex items-center gap-3">
					{onClose && (
						<button
							className="flex items-center justify-center w-10 h-10 rounded-xl bg-gray-800/80 border border-gray-600 hover:bg-gray-700 hover:border-gray-500 transition-all duration-200 backdrop-blur-sm"
							aria-label="Back"
							onClick={onClose}
						>
							<svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
								<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
							</svg>
						</button>
					)}
					<div>
						<h2 className="text-xl font-bold text-white">Select Sharp Book Limit</h2>
					</div>
				</div>
				<button 
					onClick={onClose} 
					className="flex items-center justify-center w-10 h-10 rounded-xl bg-gray-800/80 border border-gray-600 hover:bg-gray-700 hover:border-gray-500 transition-all duration-200 backdrop-blur-sm"
					aria-label="Close"
				>
					<svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
						<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
					</svg>
				</button>
			</div>
			
			<div className="flex-1 overflow-y-auto space-y-4">
					{/* Description */}
					<div className="space-y-3">
						<p className="text-base text-gray-400">
							Where available, filter for plays where sharp books are accepting bet sizes over:
						</p>
					
					{/* Current Value Display */}
					<div className="flex items-center justify-center py-4">
						<span className="text-4xl font-bold text-gray-300">$</span>
						<span className="text-5xl font-bold ml-2 text-white">
							{parseInt(input).toLocaleString()}
						</span>
					</div>
					
					{/* Keypad */}
					<div className="w-full max-w-xs mx-auto">
						<div className="grid grid-cols-3 gap-3 mb-4">
							{[1,2,3,4,5,6,7,8,9].map(n => (
								<button
									key={n}
									className="bg-gray-800 text-white text-2xl rounded-xl py-4 hover:bg-blue-700 active:bg-blue-700 focus:outline-none focus:ring-0 focus:bg-gray-800 transition-colors font-semibold touch-manipulation"
									onClick={() => handleKey(n.toString())}
									onTouchEnd={(e) => {
										e.currentTarget.blur();
									}}
									onMouseUp={(e) => {
										e.currentTarget.blur();
									}}
								>
									{n}
								</button>
							))}
							<div></div>
							<button
								className="bg-gray-800 text-white text-2xl rounded-xl py-4 hover:bg-blue-700 active:bg-blue-700 focus:outline-none focus:ring-0 focus:bg-gray-800 transition-colors font-semibold touch-manipulation"
								onClick={() => handleKey('0')}
								onTouchEnd={(e) => {
									e.currentTarget.blur();
								}}
								onMouseUp={(e) => {
									e.currentTarget.blur();
								}}
							>
								0
							</button>
							<button
								className="bg-gray-800 text-white text-2xl rounded-xl py-4 hover:bg-blue-700 active:bg-blue-700 focus:outline-none focus:ring-0 focus:bg-gray-800 transition-colors font-semibold touch-manipulation"
								onClick={handleBackspace}
								onTouchEnd={(e) => {
									e.currentTarget.blur();
								}}
								onMouseUp={(e) => {
									e.currentTarget.blur();
								}}
							>
								←
							</button>
							<button
								className="bg-blue-600 text-white text-xl rounded-xl py-4 hover:bg-blue-700 active:bg-blue-700 focus:outline-none focus:ring-0 focus:bg-blue-600 transition-colors col-span-3 font-semibold touch-manipulation"
								onClick={handleSubmit}
								onTouchEnd={(e) => {
									e.currentTarget.blur();
								}}
								onMouseUp={(e) => {
									e.currentTarget.blur();
								}}
							>
								Save
							</button>
						</div>
					</div>
					
					{/* Full Description */}
					<div className="space-y-3">
						<p className="text-sm text-gray-500 leading-relaxed">
							Sharp books allow larger bet sizes when they are more confident on a market. Setting a minimum sharp book limit helps filter out plays sharp books are less confident about.
						</p>
						<p className="text-sm text-gray-500 leading-relaxed">
							For beginners, we recommend setting this filter to $2,000+.
						</p>
					</div>
				</div>
			</div>
		</div>,
		document.body
	);
};

// Min/Max EV Content Component - Integrated keypad without modal overlay
const MinMaxEVContent = ({ filters, activeRowIdx, setFilters, email, onClose }) => {
	const [editingMin, setEditingMin] = useState(false);
	const [editingMax, setEditingMax] = useState(false);
	const [minInput, setMinInput] = useState('');
	const [maxInput, setMaxInput] = useState('');
	const [validationError, setValidationError] = useState('');

	const minEV = filters[activeRowIdx]?.minMaxEv?.[0] ?? null;
	const maxEV = filters[activeRowIdx]?.minMaxEv?.[1] ?? null;

	useEffect(() => {
		if (!editingMin) {
			setMinInput(minEV === null || minEV === undefined || minEV === -9999999 ? '' : minEV.toString());
		}
	}, [minEV, editingMin]);

	useEffect(() => {
		if (!editingMax) {
			setMaxInput(maxEV === null || maxEV === undefined || maxEV === 9999999 ? '' : maxEV.toString());
		}
	}, [maxEV, editingMax]);

	const handleKey = (num, isMin) => {
		if (validationError) {
			setValidationError(''); // Clear error when user starts typing
		}
		const currentInput = isMin ? minInput : maxInput;
		if (currentInput.length >= 5) return; // Allow for negative sign
		if (currentInput === '0' || currentInput === '-0') {
			if (isMin) {
				setMinInput(currentInput.startsWith('-') ? '-' + num : num);
			} else {
				setMaxInput(currentInput.startsWith('-') ? '-' + num : num);
			}
		} else {
			if (isMin) {
				setMinInput(minInput + num);
			} else {
				setMaxInput(maxInput + num);
			}
		}
	};

	const handleToggleSign = (isMin) => {
		if (validationError) {
			setValidationError(''); // Clear error when user toggles sign
		}
		if (isMin) {
			setMinInput(minInput.startsWith('-') ? minInput.slice(1) : '-' + minInput);
		} else {
			setMaxInput(maxInput.startsWith('-') ? maxInput.slice(1) : '-' + maxInput);
		}
	};

	const handleBackspace = (isMin) => {
		if (validationError) {
			setValidationError(''); // Clear error when user uses backspace
		}
		if (isMin) {
			if (minInput.length === 1) {
				setMinInput('0');
			} else {
				setMinInput(minInput.slice(0, -1));
			}
		} else {
			if (maxInput.length === 1) {
				setMaxInput('0');
			} else {
				setMaxInput(maxInput.slice(0, -1));
			}
		}
	};

	const handleSetToAny = async (isMin) => {
		setValidationError('');
		const copy = JSON.parse(JSON.stringify(filters));
		if (isMin) {
			copy[activeRowIdx].minMaxEv[0] = -9999999;
		} else {
			copy[activeRowIdx].minMaxEv[1] = 9999999;
		}
		setFilters(copy);
		const userdb = JSON.parse(window.localStorage.getItem('userdb') || 'null');
		const selectedName = userdb?.selected_query || (userdb?.queries?.[0]?.[0]?.name ?? 'default');
		const idx = userdb?.queries.findIndex(q => q?.[0]?.name === selectedName);
		if (idx !== -1) {
			if (userdb?.queries) userdb.queries[idx] = copy;
			window.localStorage.setItem('userdb', JSON.stringify(userdb));
			await saveUserInfo(copy, email, false);
		}
		if (isMin) {
			setEditingMin(false);
		} else {
			setEditingMax(false);
		}
	};

	const handleSubmit = async (isMin) => {
		setValidationError(''); // Clear any previous errors
		const input = isMin ? minInput : maxInput;
		if (input === '' || input === '-') {
			// Set to default "Any" value
			const copy = JSON.parse(JSON.stringify(filters));
			if (isMin) {
				copy[activeRowIdx].minMaxEv[0] = -9999999;
			} else {
				copy[activeRowIdx].minMaxEv[1] = 9999999;
			}
			setFilters(copy);
			const userdb = JSON.parse(window.localStorage.getItem('userdb') || 'null');
			const selectedName = userdb?.selected_query || (userdb?.queries?.[0]?.[0]?.name ?? 'default');
			const idx = userdb?.queries.findIndex(q => q?.[0]?.name === selectedName);
			if (idx !== -1) {
				if (userdb?.queries) userdb.queries[idx] = copy;
				window.localStorage.setItem('userdb', JSON.stringify(userdb));
				await saveUserInfo(copy, email, false);
			}
			if (isMin) {
				setEditingMin(false);
			} else {
				setEditingMax(false);
			}
			return;
		}
		const val = parseInt(input, 10);
		if (!isNaN(val)) {
			const copy = JSON.parse(JSON.stringify(filters));
			const currentMin = copy[activeRowIdx].minMaxEv[0];
			const currentMax = copy[activeRowIdx].minMaxEv[1];
			
			if (isMin) {
				// If setting minimum, ensure it's not greater than maximum (unless max is "Any")
				if (currentMax !== null && currentMax !== undefined && val > currentMax) {
					// Don't allow minimum to be greater than maximum
					setValidationError('Minimum EV cannot be greater than maximum EV');
					return;
				}
				copy[activeRowIdx].minMaxEv[0] = val;
			} else {
				// If setting maximum, ensure it's not less than minimum (unless min is "Any")
				if (currentMin !== null && currentMin !== undefined && val < currentMin) {
					// Don't allow maximum to be less than minimum
					setValidationError('Maximum EV cannot be less than minimum EV');
					return;
				}
				copy[activeRowIdx].minMaxEv[1] = val;
			}
			setFilters(copy);
			const userdb = JSON.parse(window.localStorage.getItem('userdb') || 'null');
			const selectedName = userdb?.selected_query || (userdb?.queries?.[0]?.[0]?.name ?? 'default');
			const idx = userdb?.queries.findIndex(q => q?.[0]?.name === selectedName);
			if (idx !== -1) {
				if (userdb?.queries) userdb.queries[idx] = copy;
				window.localStorage.setItem('userdb', JSON.stringify(userdb));
				await saveUserInfo(copy, email, false);
			}
			if (isMin) {
				setEditingMin(false);
			} else {
				setEditingMax(false);
			}
		}
	};

	const formatEV = (value) => {
		if (value === null || value === undefined || value === -9999999 || value === 9999999) return 'Any';
		return `${value}%`;
	};

	const currentInput = editingMin ? minInput : (editingMax ? maxInput : '');
	const isEditing = editingMin || editingMax;

	return createPortal(
		<div style={{zIndex: 10000}} className="bg-gray-900 text-white fixed top-0 left-0 w-full h-full p-4 flex flex-col">
			<div className="flex items-center justify-between mb-6">
				<div className="flex items-center gap-3">
					{onClose && (
						<button
							className="flex items-center justify-center w-10 h-10 rounded-xl bg-gray-800/80 border border-gray-600 hover:bg-gray-700 hover:border-gray-500 transition-all duration-200 backdrop-blur-sm"
							aria-label="Back"
							onClick={onClose}
						>
							<svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
								<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
							</svg>
						</button>
					)}
					<div>
						<h2 className="text-xl font-bold text-white">Min/Max EV%</h2>
					</div>
				</div>
				<button 
					onClick={onClose} 
					className="flex items-center justify-center w-10 h-10 rounded-xl bg-gray-800/80 border border-gray-600 hover:bg-gray-700 hover:border-gray-500 transition-all duration-200 backdrop-blur-sm"
					aria-label="Close"
				>
					<svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
						<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
					</svg>
				</button>
			</div>
			
			<div className="flex-1 overflow-y-auto space-y-6">
				{/* Minimum EV Section - Only show when not editing max, or when editing min */}
				{(!isEditing || editingMin) && (
					<div className="space-y-3">
						<p className="text-base text-gray-400">Minimum EV%</p>
						<div className="flex items-center justify-center py-4">
							<span className="text-5xl font-bold text-white">
								{editingMin ? `${currentInput || '0'}%` : formatEV(minEV)}
							</span>
						</div>
						{!editingMin && !editingMax && (
							<button
								onClick={() => {
								setEditingMin(true);
								setMinInput(minEV === null || minEV === undefined || minEV === -9999999 ? '' : minEV.toString());
								setValidationError('');
								}}
								className="w-full bg-gray-800 text-white py-3 rounded-xl hover:bg-gray-700 transition-colors"
							>
								Edit Minimum
							</button>
						)}
					</div>
				)}

				{/* Maximum EV Section - Only show when not editing min, or when editing max */}
				{(!isEditing || editingMax) && (
					<div className="space-y-3">
						<p className="text-base text-gray-400">Maximum EV%</p>
						<div className="flex items-center justify-center py-4">
							<span className="text-5xl font-bold text-white">
								{editingMax ? `${currentInput || '0'}%` : formatEV(maxEV)}
							</span>
						</div>
						{!editingMin && !editingMax && (
							<button
								onClick={() => {
								setEditingMax(true);
								setMaxInput(maxEV === null || maxEV === undefined || maxEV === 9999999 ? '' : maxEV.toString());
								setValidationError('');
								}}
								className="w-full bg-gray-800 text-white py-3 rounded-xl hover:bg-gray-700 transition-colors"
							>
								Edit Maximum
							</button>
						)}
					</div>
				)}

				{/* Validation Error Message */}
				{validationError && (
					<div className="text-red-500 text-center text-sm mt-2">
						{validationError}
					</div>
				)}

				{/* Keypad - Only show when editing */}
				{isEditing && (
					<div className="w-full max-w-xs mx-auto">
						<div className="grid grid-cols-3 gap-3 mb-4">
							{[1,2,3,4,5,6,7,8,9].map(n => (
								<button
									key={n}
									className="bg-gray-800 text-white text-2xl rounded-xl py-4 hover:bg-blue-700 active:bg-blue-700 focus:outline-none focus:ring-0 focus:bg-gray-800 transition-colors font-semibold touch-manipulation"
									onClick={() => handleKey(n.toString(), editingMin)}
									onTouchEnd={(e) => {
										e.currentTarget.blur();
									}}
									onMouseUp={(e) => {
										e.currentTarget.blur();
									}}
								>
									{n}
								</button>
							))}
							<button
								className="bg-gray-800 text-white text-2xl rounded-xl py-4 hover:bg-blue-700 active:bg-blue-700 focus:outline-none focus:ring-0 focus:bg-gray-800 transition-colors font-semibold touch-manipulation"
								onClick={() => handleToggleSign(editingMin)}
								onTouchEnd={(e) => {
									e.currentTarget.blur();
								}}
								onMouseUp={(e) => {
									e.currentTarget.blur();
								}}
							>
								±
							</button>
							<button
								className="bg-gray-800 text-white text-2xl rounded-xl py-4 hover:bg-blue-700 active:bg-blue-700 focus:outline-none focus:ring-0 focus:bg-gray-800 transition-colors font-semibold touch-manipulation"
								onClick={() => handleKey('0', editingMin)}
								onTouchEnd={(e) => {
									e.currentTarget.blur();
								}}
								onMouseUp={(e) => {
									e.currentTarget.blur();
								}}
							>
								0
							</button>
							<button
								className="bg-gray-800 text-white text-2xl rounded-xl py-4 hover:bg-blue-700 active:bg-blue-700 focus:outline-none focus:ring-0 focus:bg-gray-800 transition-colors font-semibold touch-manipulation"
								onClick={() => handleBackspace(editingMin)}
								onTouchEnd={(e) => {
									e.currentTarget.blur();
								}}
								onMouseUp={(e) => {
									e.currentTarget.blur();
								}}
							>
								←
							</button>
							<button
								className="bg-blue-600 text-white text-xl rounded-xl py-4 hover:bg-blue-700 active:bg-blue-700 focus:outline-none focus:ring-0 focus:bg-blue-600 transition-colors col-span-3 font-semibold touch-manipulation"
								onClick={() => handleSubmit(editingMin)}
								onTouchEnd={(e) => {
									e.currentTarget.blur();
								}}
								onMouseUp={(e) => {
									e.currentTarget.blur();
								}}
							>
								Save
							</button>
						</div>
						<div className="flex gap-2">
							<button
								onClick={() => handleSetToAny(editingMin)}
								className="flex-1 text-gray-400 hover:text-white py-2 rounded-lg border border-gray-600 hover:border-gray-500"
							>
								Set to Any
							</button>
							<button
								onClick={() => {
									setEditingMin(false);
									setEditingMax(false);
									setValidationError('');
								}}
								className="flex-1 text-gray-400 hover:text-white py-2 rounded-lg"
							>
								Cancel
							</button>
						</div>
					</div>
				)}
			</div>
		</div>,
		document.body
	);
};

// Min/Max Odds Content Component - Integrated keypad without modal overlay
const MinMaxOddsContent = ({ filters, activeRowIdx, setFilters, email, onClose }) => {
	const [editingMin, setEditingMin] = useState(false);
	const [editingMax, setEditingMax] = useState(false);
	const [minInput, setMinInput] = useState('');
	const [maxInput, setMaxInput] = useState('');
	const [validationError, setValidationError] = useState('');

	const minOdds = filters[activeRowIdx]?.minMaxOdds?.[0] ?? null;
	const maxOdds = filters[activeRowIdx]?.minMaxOdds?.[1] ?? null;

	useEffect(() => {
		if (!editingMin) {
			setMinInput(minOdds === null || minOdds === undefined || minOdds === -9999999 ? '' : minOdds.toString());
		}
	}, [minOdds, editingMin]);

	useEffect(() => {
		if (!editingMax) {
			setMaxInput(maxOdds === null || maxOdds === undefined || maxOdds === 9999999 ? '' : maxOdds.toString());
		}
	}, [maxOdds, editingMax]);

	const handleKey = (num, isMin) => {
		if (validationError) {
			setValidationError(''); // Clear error when user starts typing
		}
		const currentInput = isMin ? minInput : maxInput;
		if (currentInput.length >= 6) return; // Allow for negative sign and 5 digits
		if (currentInput === '0' || currentInput === '-0') {
			if (isMin) {
				setMinInput(currentInput.startsWith('-') ? '-' + num : num);
			} else {
				setMaxInput(currentInput.startsWith('-') ? '-' + num : num);
			}
		} else {
			if (isMin) {
				setMinInput(minInput + num);
			} else {
				setMaxInput(maxInput + num);
			}
		}
	};

	const handleToggleSign = (isMin) => {
		if (validationError) {
			setValidationError(''); // Clear error when user toggles sign
		}
		if (isMin) {
			setMinInput(minInput.startsWith('-') ? minInput.slice(1) : '-' + minInput);
		} else {
			setMaxInput(maxInput.startsWith('-') ? maxInput.slice(1) : '-' + maxInput);
		}
	};

	const handleBackspace = (isMin) => {
		if (validationError) {
			setValidationError(''); // Clear error when user uses backspace
		}
		if (isMin) {
			if (minInput.length === 1 || (minInput.length === 2 && minInput.startsWith('-'))) {
				setMinInput('0');
			} else {
				setMinInput(minInput.slice(0, -1));
			}
		} else {
			if (maxInput.length === 1 || (maxInput.length === 2 && maxInput.startsWith('-'))) {
				setMaxInput('0');
			} else {
				setMaxInput(maxInput.slice(0, -1));
			}
		}
	};

	const handleSetToAny = async (isMin) => {
		setValidationError('');
		const copy = JSON.parse(JSON.stringify(filters));
		if (isMin) {
			copy[activeRowIdx].minMaxOdds[0] = -9999999;
		} else {
			copy[activeRowIdx].minMaxOdds[1] = 9999999;
		}
		setFilters(copy);
		const userdb = JSON.parse(window.localStorage.getItem('userdb') || 'null');
		const selectedName = userdb?.selected_query || (userdb?.queries?.[0]?.[0]?.name ?? 'default');
		const idx = userdb?.queries.findIndex(q => q?.[0]?.name === selectedName);
		if (idx !== -1) {
			if (userdb?.queries) userdb.queries[idx] = copy;
			window.localStorage.setItem('userdb', JSON.stringify(userdb));
			await saveUserInfo(copy, email, false);
		}
		if (isMin) {
			setEditingMin(false);
		} else {
			setEditingMax(false);
		}
	};

	const handleSubmit = async (isMin) => {
		setValidationError(''); // Clear any previous errors
		const input = isMin ? minInput : maxInput;
		if (input === '' || input === '-') {
			// Set to default "Any" value
			const copy = JSON.parse(JSON.stringify(filters));
			if (isMin) {
				copy[activeRowIdx].minMaxOdds[0] = -9999999;
			} else {
				copy[activeRowIdx].minMaxOdds[1] = 9999999;
			}
			setFilters(copy);
			const userdb = JSON.parse(window.localStorage.getItem('userdb') || 'null');
			const selectedName = userdb?.selected_query || (userdb?.queries?.[0]?.[0]?.name ?? 'default');
			const idx = userdb?.queries.findIndex(q => q?.[0]?.name === selectedName);
			if (idx !== -1) {
				if (userdb?.queries) userdb.queries[idx] = copy;
				window.localStorage.setItem('userdb', JSON.stringify(userdb));
				await saveUserInfo(copy, email, false);
			}
			if (isMin) {
				setEditingMin(false);
			} else {
				setEditingMax(false);
			}
			return;
		}
		const val = parseInt(input, 10);
		if (!isNaN(val)) {
			// Validate odds: cannot be between -100 and +100 (excluding -100 and +100)
			if (val > -100 && val < 100) {
				setValidationError('Odds must be less than or equal to -100 or greater than or equal to +100');
				return;
			}
			
			const copy = JSON.parse(JSON.stringify(filters));
			const currentMin = copy[activeRowIdx].minMaxOdds[0];
			const currentMax = copy[activeRowIdx].minMaxOdds[1];
			
			if (isMin) {
				// If setting minimum, ensure it's not greater than maximum (unless max is "Any")
				if (currentMax !== null && currentMax !== undefined && val > currentMax) {
					// Don't allow minimum to be greater than maximum
					setValidationError('Minimum odds cannot be greater than maximum odds');
					return;
				}
				copy[activeRowIdx].minMaxOdds[0] = val;
			} else {
				// If setting maximum, ensure it's not less than minimum (unless min is "Any")
				if (currentMin !== null && currentMin !== undefined && val < currentMin) {
					// Don't allow maximum to be less than minimum
					setValidationError('Maximum odds cannot be less than minimum odds');
					return;
				}
				copy[activeRowIdx].minMaxOdds[1] = val;
			}
			setFilters(copy);
			const userdb = JSON.parse(window.localStorage.getItem('userdb') || 'null');
			const selectedName = userdb?.selected_query || (userdb?.queries?.[0]?.[0]?.name ?? 'default');
			const idx = userdb?.queries.findIndex(q => q?.[0]?.name === selectedName);
			if (idx !== -1) {
				if (userdb?.queries) userdb.queries[idx] = copy;
				window.localStorage.setItem('userdb', JSON.stringify(userdb));
				await saveUserInfo(copy, email, false);
			}
			if (isMin) {
				setEditingMin(false);
			} else {
				setEditingMax(false);
			}
		}
	};

	const formatOdds = (value) => {
		if (value === null || value === undefined || value === -9999999 || value === 9999999) return 'Any';
		return value > 0 ? `+${value}` : value.toString();
	};

	const currentInput = editingMin ? minInput : (editingMax ? maxInput : '');
	const isEditing = editingMin || editingMax;
	const displayValue = currentInput || '0';
	const formattedDisplay = displayValue === '0' ? '0' : parseInt(displayValue) > 0 ? `+${displayValue}` : displayValue;

	return createPortal(
		<div style={{zIndex: 10000}} className="bg-gray-900 text-white fixed top-0 left-0 w-full h-full p-4 flex flex-col">
			<div className="flex items-center justify-between mb-6">
				<div className="flex items-center gap-3">
					{onClose && (
						<button
							className="flex items-center justify-center w-10 h-10 rounded-xl bg-gray-800/80 border border-gray-600 hover:bg-gray-700 hover:border-gray-500 transition-all duration-200 backdrop-blur-sm"
							aria-label="Back"
							onClick={onClose}
						>
							<svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
								<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
							</svg>
						</button>
					)}
					<div>
						<h2 className="text-xl font-bold text-white">Min/Max Odds</h2>
					</div>
				</div>
				<button 
					onClick={onClose} 
					className="flex items-center justify-center w-10 h-10 rounded-xl bg-gray-800/80 border border-gray-600 hover:bg-gray-700 hover:border-gray-500 transition-all duration-200 backdrop-blur-sm"
					aria-label="Close"
				>
					<svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
						<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
					</svg>
				</button>
			</div>
			
			<div className="flex-1 overflow-y-auto space-y-6">
				{/* Minimum Odds Section - Only show when not editing max, or when editing min */}
				{(!isEditing || editingMin) && (
					<div className="space-y-3">
						<p className="text-base text-gray-400">Minimum Odds</p>
						<div className="flex items-center justify-center py-4">
							<span className="text-5xl font-bold text-white">
								{editingMin ? formattedDisplay : formatOdds(minOdds)}
							</span>
						</div>
						{!editingMin && !editingMax && (
							<button
								onClick={() => {
									setEditingMin(true);
									setMinInput(minOdds === null || minOdds === undefined || minOdds === -9999999 ? '' : minOdds.toString());
									setValidationError('');
								}}
								className="w-full bg-gray-800 text-white py-3 rounded-xl hover:bg-gray-700 transition-colors"
							>
								Edit Minimum
							</button>
						)}
					</div>
				)}

				{/* Maximum Odds Section - Only show when not editing min, or when editing max */}
				{(!isEditing || editingMax) && (
					<div className="space-y-3">
						<p className="text-base text-gray-400">Maximum Odds</p>
						<div className="flex items-center justify-center py-4">
							<span className="text-5xl font-bold text-white">
								{editingMax ? formattedDisplay : formatOdds(maxOdds)}
							</span>
						</div>
						{!editingMin && !editingMax && (
							<button
								onClick={() => {
									setEditingMax(true);
									setMaxInput(maxOdds === null || maxOdds === undefined || maxOdds === 9999999 ? '' : maxOdds.toString());
									setValidationError('');
								}}
								className="w-full bg-gray-800 text-white py-3 rounded-xl hover:bg-gray-700 transition-colors"
							>
								Edit Maximum
							</button>
						)}
					</div>
				)}

				{/* Validation Error Message */}
				{validationError && (
					<div className="text-red-500 text-center text-sm mt-2">
						{validationError}
					</div>
				)}

				{/* Keypad - Only show when editing */}
				{isEditing && (
					<div className="w-full max-w-xs mx-auto">
						<div className="grid grid-cols-3 gap-3 mb-4">
							{[1,2,3,4,5,6,7,8,9].map(n => (
								<button
									key={n}
									className="bg-gray-800 text-white text-2xl rounded-xl py-4 hover:bg-blue-700 active:bg-blue-700 focus:outline-none focus:ring-0 focus:bg-gray-800 transition-colors font-semibold touch-manipulation"
									onClick={() => handleKey(n.toString(), editingMin)}
									onTouchEnd={(e) => {
										e.currentTarget.blur();
									}}
									onMouseUp={(e) => {
										e.currentTarget.blur();
									}}
								>
									{n}
								</button>
							))}
							<button
								className="bg-gray-800 text-white text-2xl rounded-xl py-4 hover:bg-blue-700 active:bg-blue-700 focus:outline-none focus:ring-0 focus:bg-gray-800 transition-colors font-semibold touch-manipulation"
								onClick={() => handleToggleSign(editingMin)}
								onTouchEnd={(e) => {
									e.currentTarget.blur();
								}}
								onMouseUp={(e) => {
									e.currentTarget.blur();
								}}
							>
								±
							</button>
							<button
								className="bg-gray-800 text-white text-2xl rounded-xl py-4 hover:bg-blue-700 active:bg-blue-700 focus:outline-none focus:ring-0 focus:bg-gray-800 transition-colors font-semibold touch-manipulation"
								onClick={() => handleKey('0', editingMin)}
								onTouchEnd={(e) => {
									e.currentTarget.blur();
								}}
								onMouseUp={(e) => {
									e.currentTarget.blur();
								}}
							>
								0
							</button>
							<button
								className="bg-gray-800 text-white text-2xl rounded-xl py-4 hover:bg-blue-700 active:bg-blue-700 focus:outline-none focus:ring-0 focus:bg-gray-800 transition-colors font-semibold touch-manipulation"
								onClick={() => handleBackspace(editingMin)}
								onTouchEnd={(e) => {
									e.currentTarget.blur();
								}}
								onMouseUp={(e) => {
									e.currentTarget.blur();
								}}
							>
								←
							</button>
							<button
								className="bg-blue-600 text-white text-xl rounded-xl py-4 hover:bg-blue-700 active:bg-blue-700 focus:outline-none focus:ring-0 focus:bg-blue-600 transition-colors col-span-3 font-semibold touch-manipulation"
								onClick={() => handleSubmit(editingMin)}
								onTouchEnd={(e) => {
									e.currentTarget.blur();
								}}
								onMouseUp={(e) => {
									e.currentTarget.blur();
								}}
							>
								Save
							</button>
						</div>
						<div className="flex gap-2">
							<button
								onClick={() => handleSetToAny(editingMin)}
								className="flex-1 text-gray-400 hover:text-white py-2 rounded-lg border border-gray-600 hover:border-gray-500"
							>
								Set to Any
							</button>
							<button
								onClick={() => {
									setEditingMin(false);
									setEditingMax(false);
									setValidationError('');
								}}
								className="flex-1 text-gray-400 hover:text-white py-2 rounded-lg"
							>
								Cancel
							</button>
						</div>
					</div>
				)}
			</div>
		</div>,
		document.body
	);
};

const FiltersMobileBar = ({ onClose, setFilterView, setActiveRowIdx, filterss, setFiltersBarOpen, setFilters, queries, setUser, user, setQueries, setNewQueryName, newQueryNameRef, email, previousView, setPreviousView, isAddConditionView, setIsAddConditionView, addConditionRowIdx, setAddConditionRowIdx, setIsSpecificViewRef }) => {
	console.log('filterss', filterss);
	const [isSpecificView, setIsSpecificView] = useState(true);
	
	// Expose setIsSpecificView to parent via ref
	useEffect(() => {
		if (setIsSpecificViewRef) {
			setIsSpecificViewRef.current = setIsSpecificView;
		}
	}, [setIsSpecificViewRef]);
	
	// When isAddConditionView becomes true, ensure isSpecificView is false immediately
	// Use useLayoutEffect to run synchronously before paint to prevent flicker
	useLayoutEffect(() => {
		if (isAddConditionView) {
			setIsSpecificView(false);
		}
	}, [isAddConditionView]);
	
	const [isRemoveConditionView, setIsRemoveConditionView] = useState(false);
	const [editingNameIdx, setEditingNameIdx] = useState(null);
	const [isSavedFiltersOpen, setIsSavedFiltersOpen] = useState(false);
	const [isNewFilterModalOpen, setIsNewFilterModalOpen] = useState(false);
	const [isDeleteFilterModalOpen, setIsDeleteFilterModalOpen] = useState(false);
	const [newFilterName, setNewFilterName] = useState('');
	const [filterToDelete, setFilterToDelete] = useState(null);
	const [confirmRemoveModal, setConfirmRemoveModal] = useState({ open: false, rowIdx: null, key: null });
	const [saved, setSaved] = useState(false);

	// When isAddConditionView becomes true, ensure isSpecificView is false
	useEffect(() => {
		if (isAddConditionView) {
			setIsSpecificView(false);
		}
	}, [isAddConditionView]);

	// Helper function to check if a property has been changed from its default value
	const isPropertyChanged = (key, value) => {
		// dateDifference is an internal property and should never be displayed as a filter option
		if (key === 'dateDifference') {
			return false;
		}
		
		if (Array.isArray(value)) {
			if (key === 'minMaxEv') {
				// Check if both are sentinel values or null (default/Any)
				return !((value[0] === -9999999 || value[0] === null) && (value[1] === 9999999 || value[1] === null));
			}
			if (key === 'minMaxOdds') {
				// Check if both are sentinel values or null (default/Any)
				return !((value[0] === -9999999 || value[0] === null) && (value[1] === 9999999 || value[1] === null));
			}
			return value.length > 0;
		}
		if (key === 'limit') {
			return value !== null && value !== '';
		}
		if (key === 'hide_alternates') {
			return value === true;
		}
		if (key === 'date') {
			return value !== null;
		}
		return !!value;
	};

	// Handle escape key
	useEffect(() => {
		const handleEscape = (e) => {
			if (e.key === 'Escape') {
				if (isRemoveConditionView) {
					setIsRemoveConditionView(false);
					setIsSpecificView(true);
					setAddConditionRowIdx(null);
				} else if (isAddConditionView) {
					setIsAddConditionView(false);
					setIsSpecificView(true);
					setAddConditionRowIdx(null);
				}
			}
		};

		window.addEventListener('keydown', handleEscape);
		return () => window.removeEventListener('keydown', handleEscape);
	}, [isRemoveConditionView, isAddConditionView]);

	// Handler to add a new query row
	const handleAddSearchBlock = () => {
		const newQueryRow = {
			sportsbooks: [
				{ label: 'bet365', value: 'bet365' },
			],
			sharpBooks: [],
			sports: [],
			leagues: [],
			markets: [],
			marketTypes: [],
			minMaxEv: [-9999999, 9999999],
			minMaxOdds: [-9999999, 9999999],
			limit: null,
			hide_alternates: false,
			date: null,
			name: '',
		};
		setFilters(prev => [...prev, newQueryRow]);
	};



	const handleRemoveCondition = (rowIdx, key) => {
		const copy = JSON.parse(JSON.stringify(filterss));
		if (['sportsbooks', 'sharpBooks', 'sports', 'leagues', 'markets', 'marketTypes'].includes(key)) {
			copy[rowIdx][key] = [];
		} else if (key === 'minMaxEv') {
			copy[rowIdx][key] = [-9999999, 9999999];
		} else if (key === 'minMaxOdds') {
			copy[rowIdx][key] = [-9999999, 9999999];
		} else if (key === 'limit') {
			copy[rowIdx][key] = null;
		} else if (key === 'hide_alternates') {
			copy[rowIdx][key] = false;
		} else if (key === 'date') {
			copy[rowIdx][key] = null;
		}
		setFilters(copy);
		setConfirmRemoveModal({ open: false, rowIdx: null, key: null });
	};

	return createPortal(
		<div style={{zIndex: 4000}} className="fixed top-0 left-0 w-full h-full bg-[#1e1e1e] text-white z-50 p-4 flex flex-col">
			{/* Top bar with Back button (if in Add/Remove Condition view), Title, and Close button */}
			<div className="flex justify-between items-center mb-6">
				{(isAddConditionView || isRemoveConditionView) ? (
					<button
						className="mr-2 text-xl font-bold"
						aria-label="Back"
						onClick={() => {
							setIsAddConditionView(false);
							setIsRemoveConditionView(false);
							setIsSpecificView(true);
							setAddConditionRowIdx(null);
						}}
						style={{ background: 'none', border: 'none', color: 'white', padding: 0, marginRight: 12 }}
					>
						&#8592;
					</button>
				) : null}
				<h2 className="text-lg font-semibold">{isRemoveConditionView ? 'Remove Conditions' : 'Filters'}</h2>
				<div className="flex-1 ml-4">
					{editingNameIdx === 0 ? (
						<input
							id={`filter-name-input-0`}
							className="p-1 rounded bg-gray-800 text-white border border-gray-600 text-sm flex-1"
							type="text"
							value={filterss && filterss[0]?.name || ''}
							autoFocus
							onChange={e => {
								if (!filterss || filterss.length === 0) return;
								const copy = [...filterss];
								copy[0] = { ...copy[0], name: e.target.value };
								setFilters(copy);
							}}
							onBlur={() => setEditingNameIdx(null)}
							onKeyDown={e => {
								if (e.key === 'Enter') setEditingNameIdx(null);
							}}
							placeholder="Enter filter name"
							style={{ minWidth: 120 }}
						/>
					) : (
						<button
							className="flex items-center gap-2 bg-transparent border-none p-0 m-0 text-left w-full"
							style={{ flex: 1, justifyContent: 'center' }}
							onClick={() => setEditingNameIdx(0)}
						>
							<span className="font-bold text-base truncate" style={{ maxWidth: 180 }}>{filterss && filterss[0]?.name || 'Tap to name this filter'}</span>
							<EditIcon fontSize="small" className="text-gray-400" />
						</button>
					)}
				</div>
				<button onClick={() => {
					if (!isAddConditionView) {
						onClose();
					} else {
						setIsAddConditionView(false)
						setIsSpecificView(true)
						setAddConditionRowIdx(null)
					}
				}} className="text-xl font-bold">
					&times;
				</button>
			</div>
			{/* Saved Filters button row, below the title/name row */}
			<div className="w-full mb-4">
				<button
					className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white text-sm px-4 py-2 rounded w-full"
					style={{ justifyContent: 'center', width: "auto" }}
					onClick={() => {
						console.log('Saved Filters button clicked, setting isSavedFiltersOpen to true');
						setIsSavedFiltersOpen(true);
					}}
				>
					<img src={eye_icon} alt="eye icon" width={20} />
					Saved Filters
				</button>
				<Modal sx={{zIndex: 10000}} open={isSavedFiltersOpen} onClose={() => setIsSavedFiltersOpen(false)}>
					<div
						style={{
							backgroundColor: '#22262e',
							width: '90%',
							margin: 'auto',
							marginTop: '10vh',
							padding: '20px',
							borderRadius: '8px',
							maxHeight: '80vh',
							overflowY: 'auto',
							position: 'relative',
							outline: 'none',
							zIndex: 10001,
						}}
						onClick={e => e.stopPropagation()}
					>
						{/* X Close Button */}
						<div
							onClick={() => setIsSavedFiltersOpen(false)}
							style={{
								position: 'absolute',
								top: '10px',
								right: '10px',
								cursor: 'pointer',
								fontSize: '24px',
								color: '#aaa',
							}}
							onMouseEnter={e => (e.target.style.color = '#fff')}
							onMouseLeave={e => (e.target.style.color = '#aaa')}
						>
							×
						</div>
						<div className="flex flex-col gap-2 mt-6">
							{queries?.map((filter, index) => (
								<div
									key={filter?.[0]?.name || index}
									style={{ color: 'white', padding: 8, borderRadius: 8, background: '#232a3a', marginBottom: 4, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
								>
									<div 
										onClick={async () => {
											// set selected query index and save to db as the actively selected query
											const access_token = window.localStorage.getItem('access_token');
											await fetch(`${process.env.REACT_APP_BACKEND_URL}/set_selected_query?email=${user?.email}&selected_query=${filter?.[0]?.name || 'default'}`, {
												headers: {
													Authorization: `Bearer ${access_token}`,
												},
											});
											setFilters(queries.find(q => q?.[0]?.name === filter?.[0]?.name));
											const copy = JSON.parse(JSON.stringify(user));
											copy.selected_query = filter?.[0]?.name || 'default';
											window.localStorage.setItem('userdb', JSON.stringify(copy));
											setUser(copy);
											setIsSavedFiltersOpen(false);
										}}
										style={{ flex: 1, cursor: 'pointer' }}
									>
										<span>{filter?.[0]?.name || 'Unnamed Filter'}</span>
									</div>
									<div className="flex gap-2">
										<button
											onClick={(e) => {
												e.stopPropagation();
												const newName = prompt('Enter new filter name:', filter?.[0]?.name || '');
												if (newName && newName.trim() && newName !== filter?.[0]?.name) {
													const updatedQueries = queries.map(q => {
														if (q?.[0]?.name === filter?.[0]?.name) {
															return [{ ...q[0], name: newName.trim() }];
														}
														return q;
													});
													setQueries(updatedQueries);
													
													// Update localStorage
													const userdb = JSON.parse(window.localStorage.getItem('userdb') || 'null');
													if (userdb) userdb.queries = updatedQueries;
													if (userdb?.selected_query === filter?.[0]?.name) {
														if (userdb) userdb.selected_query = newName.trim();
													}
													window.localStorage.setItem('userdb', JSON.stringify(userdb));
													
													// Update backend if this is the selected query
													if (userdb?.selected_query === newName.trim()) {
														const access_token = window.localStorage.getItem('access_token');
														if (access_token && (user?.email || email)) {
															fetch(`${process.env.REACT_APP_BACKEND_URL}/set_selected_query?email=${user?.email || email}&selected_query=${encodeURIComponent(newName.trim())}`, {
																headers: { Authorization: `Bearer ${access_token}` },
															});
														}
													}
													
													// Update user state
													const copy = JSON.parse(JSON.stringify(user));
													copy.selected_query = userdb?.selected_query;
													setUser(copy);
												}
											}}
											className="text-xs px-2 py-1 rounded bg-blue-600 hover:bg-blue-700 text-white"
										>
											Rename
										</button>
										<button
											onClick={(e) => {
												e.stopPropagation();
												setFilterToDelete(filter?.[0]?.name);
												setIsDeleteFilterModalOpen(true);
											}}
											className="text-xs px-2 py-1 rounded bg-red-600 hover:bg-red-700 text-white"
										>
											Delete
										</button>
									</div>
								</div>
							))}
							<div
								style={{ color: 'white', marginTop: 16, textAlign: 'center', cursor: 'pointer' }}
								onClick={() => {
									setIsSavedFiltersOpen(false);
									setIsNewFilterModalOpen(true);
								}}
							>
								<div style={{ backgroundColor: '#0e51ff', color: 'white', padding: 8, borderRadius: 8, margin: 'auto', width: 'fit-content' }}>
									Create a new filter
								</div>
							</div>
						</div>
					</div>
				</Modal>
			</div>
			
			{/* New Filter Modal */}
			<Modal 
				sx={{zIndex: 10000}} 
				open={isNewFilterModalOpen} 
				onClose={() => setIsNewFilterModalOpen(false)}
			>
				<div
					style={{
						backgroundColor: '#22262e',
						width: '90%',
						margin: 'auto',
						marginTop: '10vh',
						padding: '20px',
						borderRadius: '8px',
						maxHeight: '80vh',
						overflowY: 'auto',
						position: 'relative',
						outline: 'none',
						zIndex: 10001,
					}}
					onClick={e => e.stopPropagation()}
				>
					{/* X Close Button */}
					<div
						onClick={() => setIsNewFilterModalOpen(false)}
						style={{
							position: 'absolute',
							top: '10px',
							right: '10px',
							cursor: 'pointer',
							fontSize: '24px',
							color: '#aaa',
						}}
						onMouseEnter={e => (e.target.style.color = '#fff')}
						onMouseLeave={e => (e.target.style.color = '#aaa')}
					>
						×
					</div>
					<div className="flex flex-col gap-4 mt-6">
						<h3 className="text-white text-lg font-semibold mb-4">Create New Filter</h3>
						<input
							className="p-2 rounded bg-gray-800 text-white border border-gray-600 w-full"
							type="text"
							value={newFilterName}
							onChange={(e) => setNewFilterName(e.target.value)}
							placeholder="Enter filter name"
							autoFocus
						/>
						<div className="flex justify-end gap-3 mt-4">
							<button
								onClick={() => setIsNewFilterModalOpen(false)}
								className="px-4 py-2 text-white bg-gray-600 rounded hover:bg-gray-700"
							>
								Cancel
							</button>
							<button
								onClick={async () => {
									if (newFilterName.trim()) {
										const newFilter = [{
											sportsbooks: [
												{ label: 'bet365', value: 'bet365' },
											],
											sharpBooks: [],
											sports: [],
											leagues: [],
											markets: [],
											marketTypes: [],
											minMaxEv: [-9999999, 9999999],
											minMaxOdds: [-9999999, 9999999],
											limit: null,
											hide_alternates: false,
											date: null,
											name: newFilterName.trim(),
										}];
										
										const updatedQueries = [...(queries || []), newFilter];
										setQueries(updatedQueries);
										
										// Update localStorage
										const userdb = JSON.parse(window.localStorage.getItem('userdb') || 'null');
										if (userdb) userdb.queries = updatedQueries;
										if (userdb) userdb.selected_query = newFilterName.trim();
										window.localStorage.setItem('userdb', JSON.stringify(userdb));
										
										// Update backend
										const access_token = window.localStorage.getItem('access_token');
										if (access_token && (user?.email || email)) {
											await fetch(`${process.env.REACT_APP_BACKEND_URL}/set_selected_query?email=${user?.email || email}&selected_query=${encodeURIComponent(newFilterName.trim())}`, {
												headers: { Authorization: `Bearer ${access_token}` },
											});
										}
										
										// Update current filters and user
										setFilters(newFilter);
										const copy = JSON.parse(JSON.stringify(user));
										copy.selected_query = newFilterName.trim();
										setUser(copy);
										
										setNewFilterName('');
										setIsNewFilterModalOpen(false);
									}
								}}
								className="px-4 py-2 text-white bg-blue-600 rounded hover:bg-blue-700"
							>
								Create
							</button>
						</div>
					</div>
				</div>
			</Modal>

			{/* Delete Filter Modal */}
			<Modal 
				sx={{zIndex: 10000}} 
				open={isDeleteFilterModalOpen} 
				onClose={() => setIsDeleteFilterModalOpen(false)}
			>
				<div
					style={{
						backgroundColor: '#22262e',
						width: '90%',
						margin: 'auto',
						marginTop: '10vh',
						padding: '20px',
						borderRadius: '8px',
						maxHeight: '80vh',
						overflowY: 'auto',
						position: 'relative',
						outline: 'none',
						zIndex: 10001,
					}}
					onClick={e => e.stopPropagation()}
				>
					{/* X Close Button */}
					<div
						onClick={() => setIsDeleteFilterModalOpen(false)}
						style={{
							position: 'absolute',
							top: '10px',
							right: '10px',
							cursor: 'pointer',
							fontSize: '24px',
							color: '#aaa',
						}}
						onMouseEnter={e => (e.target.style.color = '#fff')}
						onMouseLeave={e => (e.target.style.color = '#aaa')}
					>
						×
					</div>
					<div className="flex flex-col gap-4 mt-6">
						<h3 className="text-white text-lg font-semibold mb-4">Delete Filter</h3>
						<p className="text-gray-300 mb-6">
							Are you sure you want to delete "{filterToDelete}"? This action cannot be undone.
						</p>
						<div className="flex justify-end gap-3 mt-4">
							<button
								onClick={() => setIsDeleteFilterModalOpen(false)}
								className="px-4 py-2 text-white bg-gray-600 rounded hover:bg-gray-700"
							>
								Cancel
							</button>
							<button
								onClick={async () => {
									if (filterToDelete) {
										// Find the index of the query to delete
										const queryIndex = (queries || []).findIndex(q => q?.[0]?.name === filterToDelete);
										
										// Call the backend API to delete the query
										if (queryIndex !== -1) {
											try {
												const access_token = window.localStorage.getItem('access_token');
												const userdb = JSON.parse(window.localStorage.getItem('userdb') || 'null');
												if (access_token && userdb?.email) {
													await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/query?index=${queryIndex}&email=${userdb?.email}`, {
														headers: {
															Authorization: `Bearer ${access_token}`,
														},
													});
												}
											} catch (error) {
												console.error('Error deleting query from backend:', error);
											}
										}
										
										const updatedQueries = (queries || []).filter(q => q?.[0]?.name !== filterToDelete);
										
										// If we're deleting the currently selected filter, switch to the first available one
										const userdb = JSON.parse(window.localStorage.getItem('userdb') || 'null');
										if (userdb?.selected_query === filterToDelete) {
											const newSelectedQuery = updatedQueries?.[0]?.[0]?.name || 'default';
											if (userdb) userdb.selected_query = newSelectedQuery;
											
											// Update backend
											const access_token = window.localStorage.getItem('access_token');
											if (access_token && (user?.email || email)) {
												await fetch(`${process.env.REACT_APP_BACKEND_URL}/set_selected_query?email=${user?.email || email}&selected_query=${encodeURIComponent(newSelectedQuery)}`, {
													headers: { Authorization: `Bearer ${access_token}` },
												});
											}
											
											// Update current filters and user
											setFilters(updatedQueries?.[0] || []);
											const copy = JSON.parse(JSON.stringify(user));
											copy.selected_query = newSelectedQuery;
											setUser(copy);
										}
										
										setQueries(updatedQueries);
										if (userdb) userdb.queries = updatedQueries;
										window.localStorage.setItem('userdb', JSON.stringify(userdb));
										
										setFilterToDelete(null);
										setIsDeleteFilterModalOpen(false);
									}
								}}
								className="px-4 py-2 text-white bg-red-600 rounded hover:bg-red-700"
							>
								Delete
							</button>
						</div>
					</div>
				</div>
			</Modal>
			
			{isSpecificView && (
				<div className="flex-1 overflow-y-auto">
					{filterss && filterss.map((row, rowIdx) => (
						<div key={rowIdx}>
							{Object.entries(row).map((f) => {
								// Only show properties that have been changed from their default values
								if (!isPropertyChanged(f[0], f[1])) {
									return null;
								}
								
								// Exclude dateDifference from being displayed as a filter option
								if (f[0] === 'dateDifference') {
									return null;
								}
								
								let count;
								let displayValue = null;
								if (["sportsbooks", "sharpBooks", "sports", "leagues", "markets", "marketTypes"].includes(f[0])) {
									if (f[0] === "sharpBooks") {
										count = getSharpBooksDisplayCount(f[1] || []);
									} else {
										count = f[1]?.length;
									}
								}
								if (f[0] === "minMaxEv" && Array.isArray(f[1])) {
									const formatEvValue = (value) => {
										if (value === null || value === undefined || value === -9999999 || value === 9999999) return "Any";
										return `${value}%`;
									};
									const min = formatEvValue(f[1][0]);
									const max = formatEvValue(f[1][1]);
									displayValue = { min, max };
								}
								if (f[0] === "minMaxOdds" && Array.isArray(f[1])) {
									const formatOddsValue = (value) => {
										if (value === null || value === undefined || value === -9999999 || value === 9999999) return "Any";
										return value > 0 ? `+${value}` : value.toString();
									};
									const min = formatOddsValue(f[1][0]);
									const max = formatOddsValue(f[1][1]);
									displayValue = { min, max };
								}
								if (f[0] === "date" && f[1]) {
									try {
										const dateObj = new Date(f[1]);
										displayValue = isNaN(dateObj.getTime()) ? '' : dateObj.toLocaleDateString('en-US');
									} catch {
										displayValue = '';
									}
								}
								if (f[0] === "name" && f[1]) {
									displayValue = f[1];
								}
								if (f[0] === 'name') return null;
								
								// Handle minMaxEv
								if (f[0] === "minMaxEv" && displayValue) {
									return (
										<div
											onClick={() => {
												setFilterView("minMaxEv");
												setActiveRowIdx(rowIdx);
											}}
											style={{ borderBottom: 'none' }}
											className="flex justify-between items-center py-4 cursor-pointer hover:bg-[#2a2a2a]">
											<div>
												<p>Min/Max EV%</p>
											</div>
											<div className="flex items-center gap-2">
												<span className="bg-blue-600 text-xs px-2 py-1 rounded-full">{displayValue.min} / {displayValue.max}</span>
												<span className="text-gray-400">&gt;</span>
											</div>
										</div>
									);
								}
								
								// Handle minMaxOdds
								if (f[0] === "minMaxOdds" && displayValue) {
									return (
										<div
											onClick={() => {
												setFilterView("minMaxOdds");
												setActiveRowIdx(rowIdx);
											}}
											style={{ borderBottom: 'none' }}
											className="flex justify-between items-center py-4 cursor-pointer hover:bg-[#2a2a2a]">
											<div>
												<p>Min/Max Odds</p>
											</div>
											<div className="flex items-center gap-2">
												<span className="bg-blue-600 text-xs px-2 py-1 rounded-full">{displayValue.min} / {displayValue.max}</span>
												<span className="text-gray-400">&gt;</span>
											</div>
										</div>
									);
								}
								
								// Handle hide_alternates
								if (f[0] === 'hide_alternates') {
									return (
										<div
											onClick={() => {
												setFilterView("hide_alternates");
												setActiveRowIdx(rowIdx);
											}}
											style={{ borderBottom: 'none' }}
											className="flex justify-between items-center py-4 cursor-pointer hover:bg-[#2a2a2a]">
											<div>
												<p>Hide Alternate Lines</p>
											</div>
											<div className="flex items-center gap-2">
												<span className={`bg-blue-600 text-xs px-2 py-1 rounded-full`}>{f[1] ? 'On' : 'Off'}</span>
												<span className="text-gray-400">&gt;</span>
											</div>
										</div>
									);
								}
								
								// Handle limit
								if (f[0] === 'limit') {
									return (
										<div
											onClick={() => {
												setFilterView("limit");
												setActiveRowIdx(rowIdx);
											}}
											style={{ borderBottom: 'none' }}
											className="flex justify-between items-center py-4 cursor-pointer hover:bg-[#2a2a2a]">
											<div>
												<p>Limit</p>
											</div>
											<div className="flex items-center gap-2">
												{f[1] ? (
													<span className="bg-blue-600 text-xs px-2 py-1 rounded-full">${Number(f[1]).toLocaleString()}</span>
												) : null}
												<span className="text-gray-400">&gt;</span>
											</div>
										</div>
									);
								}
								
								// Handle all other fields (sportsbooks, sharpBooks, sports, leagues, markets, marketTypes, date, name)
								return (
									<div
										key={f[0]}
										onClick={() => {
											setFilterView(f[0]);
											setActiveRowIdx(rowIdx);
										}}
										className="flex justify-between items-center py-4 cursor-pointer hover:bg-[#2a2a2a]">
										<div>
											<p>{propertyToTitleMapping[f[0]] || f[0]}</p>
										</div>
										<div className="flex items-center gap-2">
											{["minMaxOdds", "date", "name"].includes(f[0]) && displayValue ? (
												<span className="bg-blue-600 text-xs px-2 py-1 rounded-full">{displayValue}</span>
											) : count !== undefined ? (
												<span className="bg-blue-600 text-xs px-2 py-1 rounded-full">{count}</span>
											) : null}
											<span className="text-gray-400">&gt;</span>
										</div>
									</div>
								);
							})}
							{/* Add Condition and Remove Condition buttons for this query row */}
							<div style={{ width: 'fit-content', marginLeft: 'auto' }} className="mt-6 flex flex-col gap-2">
								<div className="flex gap-2">
									<button
										onClick={() => {
											setIsAddConditionView(true);
											setIsSpecificView(false);
											setIsRemoveConditionView(false);
											setAddConditionRowIdx(rowIdx);
										}}
										className="bg-blue-600 hover:bg-blue-700 text-white text-sm px-4 py-2 rounded">
										Add Condition
									</button>
									<button
										onClick={() => {
											setIsRemoveConditionView(true);
											setIsSpecificView(false);
											setIsAddConditionView(false);
											setAddConditionRowIdx(rowIdx);
										}}
										className="bg-red-600 hover:bg-red-700 text-white text-sm px-4 py-2 rounded">
										Remove Condition
									</button>
								</div>
								{/* Remove button for all rows, but disable if only one row left */}
								{filterss && filterss.length > 1 && (
									<button
										className="text-red-500 hover:text-red-700 text-xs px-2 py-1 rounded border border-red-500 mt-2 w-full"
										onClick={e => {
											e.stopPropagation();
											const copy = [...filterss];
											copy.splice(rowIdx, 1);
											setFilters(copy);
										}}
									>
										Delete Search Block
									</button>
								)}
							</div>
							{/* Divider between query rows, except after the last one */}
							{rowIdx !== (filterss ? filterss.length - 1 : 0) && (
								<div style={{ height: 1, border: '1px solid white', marginTop: 30, opacity: 0.4 }} />
							)}
						</div>
					))}
					<div style={{ height: 1, border: '1px solid white', marginTop: 30, opacity: 0.4 }} />
					<div className="mt-6 flex gap-2" style={{ justifyContent: 'flex-end' }}>
						<button
							onClick={async () => {
								try {
									const userdb = JSON.parse(window.localStorage.getItem('userdb') || 'null');
									const selectedName = userdb?.selected_query || (queries?.[0]?.[0]?.name ?? 'default');
									const updated = JSON.parse(JSON.stringify(queries || []));
									const idx = updated?.findIndex(q => q?.[0]?.name === selectedName);
									if (idx !== -1) {
										updated[idx] = filterss;
									} else if (updated?.length > 0) {
										updated[0] = filterss;
									} else {
										updated.push(filterss);
									}
									setQueries && setQueries(updated);
									if (userdb) {
										userdb.queries = updated;
										window.localStorage.setItem('userdb', JSON.stringify(userdb));
									}
									await saveUserInfo(filterss, email, false);
									setSaved(true);
									setTimeout(() => setSaved(false), 4000);
								} catch (e) {}
							}}
							className="bg-blue-600 hover:bg-blue-700 text-white text-sm px-4 py-2 rounded"
						>
							Save Filters
						</button>
						{saved && <span className="self-center text-sm" style={{ color: '#9ae6b4' }}>Saved!</span>}
						<button onClick={handleAddSearchBlock} className="bg-gray-700 hover:bg-gray-600 text-white text-sm px-4 py-2 rounded">
							Add New Search Block
						</button>
					</div>
				</div>
			)}

			{isAddConditionView && addConditionRowIdx !== null && (
				<div
					className="flex-1 overflow-y-auto"
				>
					{Object.entries(propertyToTitleMapping)
						.filter(([key]) => {
							if (key === 'name') return false;
							if (!filterss || !filterss[addConditionRowIdx]) return false;
							
							const value = filterss[addConditionRowIdx][key];
							
							// Special handling for minMaxEv - only show if it's at default values
							if (key === 'minMaxEv') {
								return !value || !Array.isArray(value) || (value[0] === -9999999 && value[1] === 9999999);
							}
							
							// Special handling for minMaxOdds - only show if it's at default values
							if (key === 'minMaxOdds') {
								return !value || !Array.isArray(value) || (value[0] === -9999999 && value[1] === 9999999);
							}
							
							// For other properties, only show if not already set
							return !value ||
								(Array.isArray(value) && value.length === 0) ||
								(typeof value !== 'object' && !value);
						})
						.map(([key, label], index) => (
							<div key={key}>
								<div
									onClick={() => {
										setPreviousView('addCondition');
										setFilterView(key);
										setActiveRowIdx(addConditionRowIdx);
										setIsAddConditionView(false);
									}}
									style={{ borderBottom: 'none' }}
									className="flex justify-between items-center py-4 cursor-pointer hover:bg-[#2a2a2a]"
								>
									<div>
										<p>{label}</p>
									</div>
									<div className="flex items-center gap-2">
										<span className="text-gray-400">&gt;</span>
									</div>
								</div>
								{index !== Object.entries(propertyToTitleMapping).filter(([key]) => {
									if (key === 'name') return false;
									if (!filterss || !filterss[addConditionRowIdx]) return false;
									
									const value = filterss[addConditionRowIdx][key];
									
									// Special handling for minMaxEv - only show if it's at default values
									if (key === 'minMaxEv') {
										return !value || !Array.isArray(value) || (value[0] === -9999999 && value[1] === 9999999);
									}
									
									// Special handling for minMaxOdds - only show if it's at default values
									if (key === 'minMaxOdds') {
										return !value || !Array.isArray(value) || (value[0] === -9999999 && value[1] === 9999999);
									}
									
									// For other properties, only show if not already set
									return !value ||
										(Array.isArray(value) && value.length === 0) ||
										(typeof value !== 'object' && !value);
								}).length - 1 && (
									<div style={{ height: 1, border: '1px solid white', marginTop: 0, opacity: 0.4 }} />
								)}
							</div>
						))}
				</div>
			)}
			{isRemoveConditionView && addConditionRowIdx !== null && (
				<div
					className="flex-1 overflow-y-auto"
				>
					{filterss && filterss[addConditionRowIdx] && Object.entries(filterss[addConditionRowIdx])
						.filter(([key, value]) => {
							if (key === 'name') return false;
							if (Array.isArray(value) && value.length === 0) return false;
							if (key === 'minMaxEv' && value[0] === -9999999 && value[1] === 9999999) return false;
							if (key === 'minMaxOdds' && value[0] === -9999999 && value[1] === 9999999) return false;
							if (key === 'limit' && !value) return false;
							if (key === 'hide_alternates' && !value) return false;
							if (key === 'date' && !value) return false;
							return true;
						})
						.map(([key, value], index) => (
							<div key={key}>
								<div
									className="flex justify-between items-center py-4 cursor-pointer hover:bg-[#2a2a2a]"
								>
									<div>
										<p>{propertyToTitleMapping[key] || key}</p>
									</div>
									<button
										onClick={() => {
											const copy = JSON.parse(JSON.stringify(filterss));
											if (['sportsbooks', 'sharpBooks', 'sports', 'leagues', 'markets', 'marketTypes'].includes(key)) {
												copy[addConditionRowIdx][key] = [];
											} else if (key === 'minMaxEv') {
												copy[addConditionRowIdx][key] = [-9999999, 9999999];
											} else if (key === 'minMaxOdds') {
												copy[addConditionRowIdx][key] = [-9999999, 9999999];
											} else if (key === 'limit') {
												copy[addConditionRowIdx][key] = null;
											} else if (key === 'hide_alternates') {
												copy[addConditionRowIdx][key] = false;
											} else if (key === 'date') {
												copy[addConditionRowIdx][key] = null;
											}
											setFilters(copy);
										}}
										className="bg-red-600 hover:bg-red-700 text-white text-sm px-3 py-1 rounded"
									>
										Remove
									</button>
								</div>
								{index !== (filterss && filterss[addConditionRowIdx] ? Object.entries(filterss[addConditionRowIdx])
									.filter(([key, value]) => {
										if (key === 'name') return false;
										if (Array.isArray(value) && value.length === 0) return false;
										if (key === 'minMaxEv' && value[0] === -9999999 && value[1] === 9999999) return false;
										if (key === 'minMaxOdds' && value[0] === -9999999 && value[1] === 9999999) return false;
										if (key === 'limit' && !value) return false;
										if (key === 'hide_alternates' && !value) return false;
										if (key === 'date' && !value) return false;
										return true;
									}) : []).length - 1 && (
									<div style={{ height: 1, border: '1px solid white', marginTop: 0, opacity: 0.4 }} />
								)}
							</div>
						))}
				</div>
			)}

			{/* Confirmation Modal */}
			<Modal
				open={confirmRemoveModal.open}
				onClose={() => setConfirmRemoveModal({ open: false, rowIdx: null, key: null })}
			>
				<div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-[#22262e] p-6 rounded-lg shadow-lg max-w-sm w-11/12">
					<h3 className="text-white text-lg font-semibold mb-4">Remove Condition</h3>
					<p className="text-gray-300 mb-6">Are you sure you want to remove this condition?</p>
					<div className="flex justify-end gap-3">
						<button
							onClick={() => setConfirmRemoveModal({ open: false, rowIdx: null, key: null })}
							className="px-4 py-2 text-white bg-gray-600 rounded hover:bg-gray-700"
						>
							Cancel
						</button>
						<button
							onClick={() => handleRemoveCondition(confirmRemoveModal.rowIdx, confirmRemoveModal.key)}
							className="px-4 py-2 text-white bg-red-600 rounded hover:bg-red-700"
						>
							Remove
						</button>
					</div>
				</div>
			</Modal>
		</div>,
		document.body
	);
};

const sportsbooksList = [
	{ id: 1, name: 'bet365', checked: true },
	{ id: 2, name: 'FanDuel', checked: true },
	{ id: 3, name: 'Pinnacle', checked: true },
	{ id: 4, name: 'Caesars', checked: false },
	{ id: 5, name: 'DraftKings', checked: false },
	{ id: 6, name: 'Fanatics', checked: false },
	{ id: 7, name: 'bet105', checked: false },
	{ id: 8, name: 'BetMGM', checked: false },
];

function getCanonicalSportsbookValue(value) {
	if (value === 'Betway (Alaska)') return 'FanDuel';
	if (value === 'bet105') return 'Pinnacle';
	return value;
}

// Dedupe alias sportsbooks so users see one entry (FanDuel, Pinnacle, etc.)
function getDedupedSharpBookOptions(sportsbookOptions) {
	const raw = [...getWagerWizDisplayOptions(), ...sportsbookOptions];
	const byCanonical = new Map();
	raw.forEach((opt) => {
		const canonical = getCanonicalSportsbookValue(opt.value);
		if (!byCanonical.has(canonical) || opt.value === 'FanDuel' || opt.value === 'Pinnacle') {
			byCanonical.set(canonical, { ...opt, label: getSportsbookDisplayName(opt.label), name: getSportsbookDisplayName(opt.name ?? opt.label) });
		}
	});
	return Array.from(byCanonical.values());
}

// Add a helper function for sportsbook equivalence
function isSportsbookEquivalent(a, b) {
	const map = {
		'ww_mains': 'WagerWiz Mains',
		'WagerWiz Mains': 'ww_mains',
		'ww_props': 'WagerWiz Props',
		'WagerWiz Props': 'ww_props',
		'WagerWiz': 'WagerWiz Mains', // WagerWiz display maps to both Mains and Props
		'Betway (Alaska)': 'FanDuel',
		'FanDuel': 'Betway (Alaska)',
		'Pinnacle': 'bet105',
		'bet105': 'Pinnacle',
	};
	return a === b || map[a] === b || map[b] === a;
}

function FilterSidebar(props) {
	const { onClose, setFilters, filters, options, property, propertyName, propertyNameSingular, groupBy, logo, children, index } = props;
	const [sidebarFilters, setSidebarFilters] = useState(
		options
			?.map((sb, idx) => ({
				id: idx + 1,
				name: sb.label,
				value: sb.value,
				checked: filters?.[index]?.[property]?.some((s) => isSportsbookEquivalent(s.value, sb.value)) ? true : false,
				...sb,
			}))
			.map((s) => ({ ...s }))
	);

	const [searchTerm, setSearchTerm] = useState('');
	const [expandedTypes, setExpandedTypes] = useState({});
	const [expandedTimes, setExpandedTimes] = useState({});
	
	// Check if this is markets filter - use special categorization
	const isMarketsFilter = property === 'markets';
	
	// Categorize markets if this is markets filter
	const categorizedMarkets = useMemo(() => {
		if (!isMarketsFilter) return null;
		return categorizeMarkets(options.map(o => o.value || o.label));
	}, [isMarketsFilter, options]);
	
	// Filter categorized markets by search term
	const filteredCategorizedMarkets = useMemo(() => {
		if (!isMarketsFilter || !categorizedMarkets || !searchTerm) return categorizedMarkets;
		
		const filtered = {};
		Object.keys(categorizedMarkets).forEach(type => {
			filtered[type] = {};
			Object.keys(categorizedMarkets[type]).forEach(time => {
				const markets = categorizedMarkets[type][time].filter(m => 
					m.label.toLowerCase().includes(searchTerm.toLowerCase())
				);
				if (markets.length > 0) {
					filtered[type][time] = markets;
				}
			});
			if (Object.keys(filtered[type]).length === 0) {
				delete filtered[type];
			}
		});
		return filtered;
	}, [isMarketsFilter, categorizedMarkets, searchTerm]);
	
	// Sort types and times for markets (same as desktop)
	const typeOrder = ['Moneyline', 'Spread', 'Total', 'Team', 'Player Prop', 'Race To', 'Other'];
	const sortedMarketTypes = filteredCategorizedMarkets ? Object.keys(filteredCategorizedMarkets).sort((a, b) => {
		const indexA = typeOrder.indexOf(a);
		const indexB = typeOrder.indexOf(b);
		if (indexA === -1 && indexB === -1) return a.localeCompare(b);
		if (indexA === -1) return 1;
		if (indexB === -1) return -1;
		return indexA - indexB;
	}) : [];
	
	const timeOrder = [
		'Game',
		'1st Half', '2nd Half',
		'1st Quarter', '2nd Quarter', '3rd Quarter', '4th Quarter', '1st 3 Quarter',
		'1st Period', '2nd Period', '3rd Period',
		'1st 10 Mins', '1st 5 Mins', 'Set', 'Inning', 'Map',
		'Golf', 'Single Over', '1st X Overs', '1st 2 innings', '1st 4 innings', '1st 7 innings', '1st 6 innings', '1st Round', '1st 3 Holes', '2nd Round'
	];
	
	const sortMarketTimes = (times) => {
		return times.sort((a, b) => {
			const indexA = timeOrder.indexOf(a);
			const indexB = timeOrder.indexOf(b);
			if (indexA === -1 && indexB === -1) return a.localeCompare(b);
			if (indexA === -1) return 1;
			if (indexB === -1) return -1;
			return indexA - indexB;
		});
	};
	
	const toggleType = (type) => {
		setExpandedTypes(prev => ({
			...prev,
			[type]: prev[type] === true ? false : true
		}));
	};
	
	const toggleTime = (typeTime) => {
		setExpandedTimes(prev => ({
			...prev,
			[typeTime]: prev[typeTime] === true ? false : true
		}));
	};
	
	// Initialize expanded states for markets - save/restore state like desktop version
	const prevSearchTermRef = useRef('');
	const savedStateRef = useRef({ types: {}, times: {} });
	const currentExpandedTypesRef = useRef({});
	const currentExpandedTimesRef = useRef({});
	
	// Keep refs in sync with state
	useEffect(() => {
		if (!isMarketsFilter) return;
		currentExpandedTypesRef.current = expandedTypes;
	}, [isMarketsFilter, expandedTypes]);
	
	useEffect(() => {
		if (!isMarketsFilter) return;
		currentExpandedTimesRef.current = expandedTimes;
	}, [isMarketsFilter, expandedTimes]);
	
	// Handle search state transitions (same as desktop version)
	useEffect(() => {
		if (!isMarketsFilter) return;
		
		const wasSearching = prevSearchTermRef.current.length > 0;
		const isSearching = searchTerm.length > 0;
		
		if (isSearching && !wasSearching) {
			// Transitioning from no search to search - save current state
			savedStateRef.current.types = { ...currentExpandedTypesRef.current };
			savedStateRef.current.times = { ...currentExpandedTimesRef.current };
			
			// Expand all matching categories for search
			const allTypes = Object.keys(filteredCategorizedMarkets || {});
			const allTimes = {};
			allTypes.forEach(type => {
				allTimes[type] = Object.keys((filteredCategorizedMarkets || {})[type] || {});
			});
			setExpandedTypes(Object.fromEntries(allTypes.map(t => [t, true])));
			setExpandedTimes(Object.fromEntries(Object.entries(allTimes).flatMap(([type, times]) => 
				times.map(time => [`${type}-${time}`, true])
			)));
		} else if (isSearching && wasSearching) {
			// Still searching - update expanded to match filtered results
			const allTypes = Object.keys(filteredCategorizedMarkets || {});
			const allTimes = {};
			allTypes.forEach(type => {
				allTimes[type] = Object.keys((filteredCategorizedMarkets || {})[type] || {});
			});
			setExpandedTypes(Object.fromEntries(allTypes.map(t => [t, true])));
			setExpandedTimes(Object.fromEntries(Object.entries(allTimes).flatMap(([type, times]) => 
				times.map(time => [`${type}-${time}`, true])
			)));
		} else if (!isSearching && wasSearching) {
			// Transitioning from search to no search - restore saved state
			setExpandedTypes(savedStateRef.current.types);
			setExpandedTimes(savedStateRef.current.times);
		}
		
		prevSearchTermRef.current = searchTerm;
	}, [isMarketsFilter, searchTerm, filteredCategorizedMarkets]);

	const toggleCheckbox = (id) => {
		setSidebarFilters((prev) => prev.map((s) => (s.id === id ? { ...s, checked: !s.checked } : s)));
	};

	const clearAll = () => {
		setSidebarFilters((prev) => prev.map((s) => ({ ...s, checked: false })));
	};

	const saveFilters = async () => {
		const selected = sidebarFilters.filter((s) => s.checked);
		const copy = JSON.parse(JSON.stringify(filters));
		copy[index][property] = selected.map((s) => {
			return { label: s.name, value: s.name };
		});
		setFilters(copy);

		const _udb = JSON.parse(window.localStorage.getItem('userdb') || 'null');
		if (_udb?.email) {
			await saveUserInfo(copy, _udb.email, false);
		}
	};

	// Custom mapping for corrections and popular category (same as desktop version)
	const customLeagueSportMap = {
		// Popular category
		'NBA': 'popular',
		'NHL': 'popular',
		'NFL': 'popular',
		'MLB': 'popular',
		'NCAAB': 'popular',
		'NCAAF': 'popular',
		// Tennis
		'ATP': 'tennis',
		'ATP Challenger': 'tennis',
		'WTA': 'tennis',
		// Soccer
		'Belarus - Premier League': 'soccer',
		'Spain - La Liga': 'soccer',
		'Spain - La Liga 2': 'soccer',
		// Football
		'CFL': 'football',
		// Esports
		'CS2': 'esports',
		'Dota 2': 'esports',
		'League of Legends': 'esports',
		'Rocket League': 'esports',
		'Valorant': 'esports',
		// Hockey
		'NCAAH': 'hockey',
		// Golf
		'PGA': 'golf',
		// MMA
		'UFC': 'mma',
		// Tennis (International Tours)
		'International - Tours': 'tennis',
		'International - Tours Women': 'tennis',
	};

	let groupedFilters = {};
	let useGrouping = !!groupBy;

	if (useGrouping) {
		sidebarFilters
			.filter((s) => s.name.toLowerCase().includes(searchTerm.toLowerCase()))
			.forEach((item) => {
				// Use customLeagueSportMap first, then LEAGUE_SPORT_MAP, then fallback to item[groupBy] or 'other'
				const leagueValue = item.value || item.name;
				const sport = customLeagueSportMap[leagueValue] || 
				             LEAGUE_SPORT_MAP[leagueValue] || 
				             item[groupBy] || 
				             'other';
				
				if (!groupedFilters[sport]) {
					groupedFilters[sport] = [];
				}
				groupedFilters[sport].push(item);
			});
		
		// Sort groups: Popular first, then alphabetically, then Other last
		const sortedGroupKeys = Object.keys(groupedFilters).sort((a, b) => {
			if (a === 'popular') return -1;
			if (b === 'popular') return 1;
			if (a === 'other') return 1;
			if (b === 'other') return -1;
			return a.localeCompare(b);
		});
		
		// Create a new sorted groupedFilters object
		const sortedGroupedFilters = {};
		sortedGroupKeys.forEach(key => {
			sortedGroupedFilters[key] = groupedFilters[key];
		});
		groupedFilters = sortedGroupedFilters;
	}

	return createPortal(
		<div style={{zIndex: 10000}} className="bg-gray-900 text-white fixed top-0 left-0 w-full h-full p-4 flex flex-col">
			<div className="flex items-center justify-between mb-6">
				<div className="flex items-center gap-3">
					{onClose && (
						<button
							className="flex items-center justify-center w-10 h-10 rounded-xl bg-gray-800/80 border border-gray-600 hover:bg-gray-700 hover:border-gray-500 transition-all duration-200 backdrop-blur-sm"
							aria-label="Back"
							onClick={onClose}
						>
							<svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
								<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
							</svg>
						</button>
					)}
					<div>
						<h2 className="text-xl font-bold text-white">Select {propertyName}</h2>
					</div>
				</div>
				<button 
					onClick={onClose} 
					className="flex items-center justify-center w-10 h-10 rounded-xl bg-gray-800/80 border border-gray-600 hover:bg-gray-700 hover:border-gray-500 transition-all duration-200 backdrop-blur-sm"
					aria-label="Close"
				>
					<svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
						<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
					</svg>
				</button>
			</div>
			{!children && (
				<>
					<div className="relative mb-6">
						{isMarketsFilter ? (
							<>
								<div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
									<img src={magnifying_glass} alt="search" className="w-4 h-4 opacity-70" />
								</div>
								<input
									type="text"
									placeholder="Search for a market"
									value={searchTerm}
									onChange={(e) => setSearchTerm(e.target.value)}
									className="w-full pl-10 pr-4 py-3 rounded-xl bg-gray-800/80 border-2 border-gray-600 placeholder-gray-400 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 backdrop-blur-sm"
									style={{ boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)' }}
								/>
							</>
						) : (
							<>
						<div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
							<svg className="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
								<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
							</svg>
						</div>
						<input
							type="text"
							placeholder={`Search for a ${propertyNameSingular}`}
							value={searchTerm}
							onChange={(e) => setSearchTerm(e.target.value)}
							className="w-full pl-10 pr-4 py-3 rounded-xl bg-gray-800/80 border-2 border-gray-600 placeholder-gray-400 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 backdrop-blur-sm"
							style={{ boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)' }}
						/>
							</>
						)}
						{searchTerm && (
							<button
								onClick={() => setSearchTerm('')}
								className="absolute inset-y-0 right-0 pr-3 flex items-center"
							>
								<svg className="h-5 w-5 text-gray-400 hover:text-gray-300 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
									<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
								</svg>
							</button>
						)}
					</div>
					<div className="overflow-y-auto" style={{ color: 'white' }}>
						{isMarketsFilter && filteredCategorizedMarkets ? (
							// Markets categorized display
							<div className="space-y-2">
								{sortedMarketTypes.map((type) => {
									const isTypeExpanded = expandedTypes[type] === true;
									const times = sortMarketTimes(Object.keys(filteredCategorizedMarkets[type] || {}));
									
									return (
										<div key={type} className="border border-gray-700 rounded-lg overflow-hidden">
											{/* Type Header */}
											<div
												onClick={() => toggleType(type)}
												className="flex items-center justify-between p-3 cursor-pointer bg-gray-800/60 hover:bg-gray-700/60 transition-colors"
											>
												<div className="flex items-center gap-2">
													<svg 
														className={`w-4 h-4 text-gray-400 transition-transform ${isTypeExpanded ? 'rotate-90' : ''}`}
														fill="currentColor" 
														viewBox="0 0 20 20"
													>
														<path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
													</svg>
													<span className="text-sm font-semibold text-gray-200">{type}</span>
													<span className="text-xs text-gray-500">
														({Object.values(filteredCategorizedMarkets[type] || {}).flat().length})
													</span>
												</div>
											</div>
											
											{/* Time Sections */}
											{isTypeExpanded && (
												<div className="bg-gray-900">
													{times.map((time) => {
														const typeTimeKey = `${type}-${time}`;
														const isTimeExpanded = expandedTimes[typeTimeKey] === true;
														const markets = filteredCategorizedMarkets[type][time] || [];
														
														return (
															<div key={typeTimeKey} className="border-t border-gray-700">
																{/* Time Header */}
																<div
																	onClick={() => toggleTime(typeTimeKey)}
																	className="flex items-center justify-between px-4 py-2 cursor-pointer bg-gray-900 hover:bg-gray-800 transition-colors"
																>
																	<div className="flex items-center gap-2">
																		<svg 
																			className={`w-3 h-3 text-gray-500 transition-transform ${isTimeExpanded ? 'rotate-90' : ''}`}
																			fill="currentColor" 
																			viewBox="0 0 20 20"
																		>
																			<path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
																		</svg>
																		<span className="text-xs font-medium text-gray-300">{time}</span>
																		<span className="text-xs text-gray-600">({markets.length})</span>
																	</div>
																</div>
																
																{/* Market Items */}
																{isTimeExpanded && (
																	<div className="pl-8 pr-2 pb-2">
																		{markets.map((market) => {
																			const marketItem = sidebarFilters.find(s => (s.value || s.name) === market.value);
																			const isChecked = marketItem?.checked || false;
																			
																			return (
																				<div
																					key={market.value}
																					onClick={() => marketItem && toggleCheckbox(marketItem.id)}
																					className="flex items-center gap-3 p-2 rounded-lg cursor-pointer hover:bg-gray-800 transition-colors"
																				>
																					<img 
																						src={isChecked ? checked_checkbox : unchecked_checkbox} 
																						alt={isChecked ? 'checked' : 'unchecked'}
																						className="w-4 h-4 flex-shrink-0"
																					/>
																					<span className={`text-xs ${isChecked ? 'text-gray-100 font-medium' : 'text-gray-400'}`}>
																						{market.label}
																					</span>
																				</div>
																			);
																		})}
																	</div>
																)}
															</div>
														);
													})}
												</div>
											)}
										</div>
									);
								})}
							</div>
						) : useGrouping ? (
							// Regular grouped display (for leagues, etc.)
							Object.entries(groupedFilters).map(([group, items]) => (
								<React.Fragment key={group}>
									<div className="text-gray-400 uppercase text-xs tracking-wider mb-3 mt-6 font-semibold">
										{group === 'popular' ? 'Popular' : 
										 group === 'other' ? 'Other' :
										 (() => {
											const sportName = SPORTS.find(s => s.value === group);
											return sportName ? sportName.label.charAt(0).toUpperCase() + sportName.label.slice(1) : group.charAt(0).toUpperCase() + group.slice(1);
										 })()}
									</div>
									<div className="grid grid-cols-3 gap-3 mb-6">
										{items.map((book) => {
											let name = getSportsbookDisplayName(book.name);
											return (
												<button
													key={book.id}
													onClick={() => toggleCheckbox(book.id)}
													className={`relative w-full px-3 py-4 rounded-xl border transition-all duration-200 flex flex-col items-center justify-center group ${
														book.checked 
															? 'bg-blue-600/90 border-blue-500 text-white shadow-lg shadow-blue-500/30' 
															: 'bg-gray-800/50 border-gray-700 text-gray-200 hover:bg-gray-700/80 hover:border-gray-600'
													}`}
													style={{ 
														minHeight: 80,
													}}
												>
													{/* Selection indicator */}
													{book.checked && (
														<div className="absolute -top-1 -right-1 w-5 h-5 bg-green-500 rounded-full flex items-center justify-center shadow-md">
															<svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
																<path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
															</svg>
														</div>
													)}
													
													{logo && (
														<div className="mb-2.5">
															<div style={{ width: 32, height: 32, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
																<LogoGenerator sportsbook={book.value} />
															</div>
														</div>
													)}
													
													<span className={`text-xs font-medium text-center leading-tight ${book.checked ? 'text-white' : 'text-gray-300'}`} style={{ wordBreak: 'break-word' }}>
														{name}
													</span>
												</button>
											);
										})}
									</div>
								</React.Fragment>
							))
						) : (
							<div className="grid grid-cols-3 gap-3 mb-6">
									{sidebarFilters
										.filter((book) => book.name.toLowerCase().includes(searchTerm.toLowerCase()))
										.map((book) => {
										let name = property === 'sports' 
											? (book.name.toLowerCase() === 'mma' ? 'MMA' : book.name.charAt(0).toUpperCase() + book.name.slice(1).toLowerCase())
											: getSportsbookDisplayName(book.name);
											return (
												<button
													key={book.id}
													onClick={() => toggleCheckbox(book.id)}
												className={`relative w-full px-3 py-4 rounded-xl border transition-all duration-200 flex flex-col items-center justify-center group ${
														book.checked 
														? 'bg-blue-600/90 border-blue-500 text-white shadow-lg shadow-blue-500/30' 
														: 'bg-gray-800/50 border-gray-700 text-gray-200 hover:bg-gray-700/80 hover:border-gray-600'
													}`}
													style={{ 
													minHeight: 80,
													}}
												>
													{/* Selection indicator */}
													{book.checked && (
													<div className="absolute -top-1 -right-1 w-5 h-5 bg-green-500 rounded-full flex items-center justify-center shadow-md">
														<svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
																<path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
															</svg>
														</div>
													)}
													
													{logo && (
													<div className="mb-2.5">
														<div style={{ width: 32, height: 32, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
																<LogoGenerator sportsbook={book.value} />
															</div>
														</div>
													)}
													
												<span className={`text-xs font-medium text-center leading-tight ${book.checked ? 'text-white' : 'text-gray-300'}`} style={{ wordBreak: 'break-word' }}>
														{name}
													</span>
												</button>
											);
										})}
								</div>
							)}
					</div>
					<div style={{ marginTop: 'auto', paddingTop: 16 }} className="flex flex-col gap-4">
						{/* Selection summary */}
						<div className="flex justify-between items-center px-4 py-3 rounded-xl bg-gray-800/40 border border-gray-700/50">
							<span className="text-sm text-gray-300 font-medium">
								{sidebarFilters.filter(s => s.checked).length} of {sidebarFilters.length} selected
							</span>
							<div className="flex gap-2">
								<button 
									onClick={clearAll} 
									className="text-xs text-gray-300 px-3 py-1.5 rounded-lg border border-gray-700 bg-gray-800/50 hover:bg-gray-700 hover:border-gray-600 transition-all duration-200 font-medium"
								>
									Clear All
								</button>
								<button 
									onClick={() => {
										setSidebarFilters((prev) => prev.map((s) => ({ ...s, checked: true })));
									}} 
									className="text-xs text-gray-300 px-3 py-1.5 rounded-lg border border-gray-700 bg-gray-800/50 hover:bg-gray-700 hover:border-gray-600 transition-all duration-200 font-medium"
								>
									Select All
								</button>
							</div>
						</div>
						
						{/* Save button */}
						<button 
							onClick={saveFilters} 
							className="w-full py-4 px-6 rounded-xl bg-blue-600 text-white font-semibold text-base shadow-lg shadow-blue-500/25 hover:bg-blue-700 hover:shadow-xl hover:shadow-blue-500/30 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-gray-900"
						>
							<div className="flex items-center justify-center gap-2">
								<svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
									<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
								</svg>
								Save Filters
							</div>
						</button>
					</div>
				</>
			)}
			{children && <>{children}</>}
		</div>,
		document.body
	);
}

export const DesktopFiltersComponentNew = (props) => {
	const {
		setIsBasicOpen,
		isFiltersSetAnchorEl,
		setIsFilterSetOpen,
		queries,
		user,
		setIsLoading,
		saved,
		setSaved,
		newQueryName,
		isScannable,
		setIsFiltersSetAnchorEl,
		executeEvScreen,
		setFiltersOpen,
		filtersOpen,
		setIsFiltersOpen,
		setNewQueryName,
		newQueryNameRef,
		setUser,
		setIsFilterSetModalOpen,
		isFilterSetModalOpen,
		setQueries,
		isFilterSetOpen,
		isBasicOpen,
		filters,
		isOracle,
		// index,
		whichFiltersOpen,
		setWhichFiltersOpen,
		setFilters,
		email,
		isDiscord,
		saveUserInfo,
	} = props;

	// Set initial state based on filters length
	if (filters?.length > 1 && isBasicOpen) {
		setIsBasicOpen(false);
	}

	const sportsbookOptions = isOracle ? SPORTSBOOKS : [];

	let sharpBooks = [...getWagerWizDisplayOptions(), ...sportsbookOptions];

	const [filterView, setFilterView] = useState();
	const [activeRowIdx, setActiveRowIdx] = useState(null);
	const [filtersBarOpen, setFiltersBarOpen] = useState(true);
	const [previousView, setPreviousView] = useState(null); // Track if we came from add condition view
	const [isAddConditionView, setIsAddConditionView] = useState(false);
	const [addConditionRowIdx, setAddConditionRowIdx] = useState(null);
	const setIsSpecificViewRef = useRef(null);

	return (
		<div>
			<div>
				{filtersBarOpen && !filterView && (
					<FiltersMobileBar
						onClose={() => {
							setFiltersBarOpen(false);
							setFiltersOpen(null);
							if (setIsFiltersOpen) {
								setIsFiltersOpen(false);
							}
						}}
						setFilterView={setFilterView}
						setActiveRowIdx={setActiveRowIdx}
						filterss={filters}
						setFiltersBarOpen={setFiltersBarOpen}
						setFilters={setFilters}
						queries={queries}
						setUser={setUser}
						user={user}
						setQueries={setQueries}
						setNewQueryName={setNewQueryName}
						newQueryNameRef={newQueryNameRef}
						email={email}
						previousView={previousView}
						setPreviousView={setPreviousView}
						isAddConditionView={isAddConditionView}
						setIsAddConditionView={setIsAddConditionView}
						addConditionRowIdx={addConditionRowIdx}
						setAddConditionRowIdx={setAddConditionRowIdx}
						setIsSpecificViewRef={setIsSpecificViewRef}
					/>
				)}
				{filterView === 'sportsbooks' && activeRowIdx !== null && (
					<FilterSidebar
						onClose={() => {
							if (previousView === 'addCondition') {
								const savedRowIdx = activeRowIdx;
								// Set isSpecificView to false FIRST, before other state updates
								if (setIsSpecificViewRef?.current) {
									setIsSpecificViewRef.current(false);
								}
							setFilterView(null);
							setActiveRowIdx(null);
								setFiltersBarOpen(true);
								setIsAddConditionView(true);
								setAddConditionRowIdx(savedRowIdx);
								setPreviousView(null);
							} else {
								setFilterView(null);
								setActiveRowIdx(null);
								setFiltersBarOpen(true);
							}
						}}
						setFilters={setFilters}
						filters={filters}
						options={SPORTSBOOKS}
						property={'sportsbooks'}
						propertyName={'sportsbooks'}
						propertyNameSingular={'sportsbook'}
						logo={true}
						index={activeRowIdx}
					/>
				)}
				{filterView === 'sharpBooks' && activeRowIdx !== null && (
					<FilterSidebar
						onClose={() => {
							if (previousView === 'addCondition') {
								const savedRowIdx = activeRowIdx;
								// Set isSpecificView to false FIRST, before other state updates
								if (setIsSpecificViewRef?.current) {
									setIsSpecificViewRef.current(false);
								}
							setFilterView(null);
							setActiveRowIdx(null);
								setFiltersBarOpen(true);
								setIsAddConditionView(true);
								setAddConditionRowIdx(savedRowIdx);
								setPreviousView(null);
							} else {
								setFilterView(null);
								setActiveRowIdx(null);
								setFiltersBarOpen(true);
							}
						}}
						setFilters={setFilters}
						filters={filters}
						options={getDedupedSharpBookOptions(sportsbookOptions)}
						property={'sharpBooks'}
						propertyName={'sharp books'}
						propertyNameSingular={'sharp book'}
						logo={true}
						index={activeRowIdx}
					/>
				)}
				{filterView === 'sports' && activeRowIdx !== null && (
					<FilterSidebar
						onClose={() => {
							if (previousView === 'addCondition') {
								const savedRowIdx = activeRowIdx;
								// Set isSpecificView to false FIRST, before other state updates
								if (setIsSpecificViewRef?.current) {
									setIsSpecificViewRef.current(false);
								}
							setFilterView(null);
							setActiveRowIdx(null);
								setFiltersBarOpen(true);
								setIsAddConditionView(true);
								setAddConditionRowIdx(savedRowIdx);
								setPreviousView(null);
							} else {
								setFilterView(null);
								setActiveRowIdx(null);
								setFiltersBarOpen(true);
							}
						}}
						setFilters={setFilters}
						filters={filters}
						options={SPORTS}
						property={'sports'}
						propertyName={'sports'}
						propertyNameSingular={'sport'}
						logo={false}
						index={activeRowIdx}
					/>
				)}
				{filterView === 'leagues' && activeRowIdx !== null && (
					<FilterSidebar
						onClose={() => {
							if (previousView === 'addCondition') {
								const savedRowIdx = activeRowIdx;
								// Set isSpecificView to false FIRST, before other state updates
								if (setIsSpecificViewRef?.current) {
									setIsSpecificViewRef.current(false);
								}
							setFilterView(null);
							setActiveRowIdx(null);
								setFiltersBarOpen(true);
								setIsAddConditionView(true);
								setAddConditionRowIdx(savedRowIdx);
								setPreviousView(null);
							} else {
								setFilterView(null);
								setActiveRowIdx(null);
								setFiltersBarOpen(true);
							}
						}}
						setFilters={setFilters}
						filters={filters}
						options={LEAGUES_CATEGORIZED}
						property={'leagues'}
						propertyName={'leagues'}
						propertyNameSingular={'league'}
						groupBy={'sport'}
						logo={false}
						index={activeRowIdx}
					/>
				)}
				{filterView === 'date' && activeRowIdx !== null && (
					<FilterSidebar
						onClose={() => {
							if (previousView === 'addCondition') {
								const savedRowIdx = activeRowIdx;
								// Set isSpecificView to false FIRST, before other state updates
								if (setIsSpecificViewRef?.current) {
									setIsSpecificViewRef.current(false);
								}
							setFilterView(null);
							setActiveRowIdx(null);
								setFiltersBarOpen(true);
								setIsAddConditionView(true);
								setAddConditionRowIdx(savedRowIdx);
								setPreviousView(null);
							} else {
								setFilterView(null);
								setActiveRowIdx(null);
								setFiltersBarOpen(true);
							}
						}}
						setFilters={setFilters}
						filters={filters}
						property={''}
						propertyName={''}
						propertyNameSingular={''}
						logo={false}
						index={activeRowIdx}
						children={<DatePickerComponent filters={filters} setFilters={setFilters} index={activeRowIdx} saveUserInfo={saveUserInfo} email={email} />}
					/>
				)}
				{filterView === 'name' && activeRowIdx !== null && (
					<FilterSidebar
						onClose={() => {
							if (previousView === 'addCondition') {
								const savedRowIdx = activeRowIdx;
								// Set isSpecificView to false FIRST, before other state updates
								if (setIsSpecificViewRef?.current) {
									setIsSpecificViewRef.current(false);
								}
							setFilterView(null);
							setActiveRowIdx(null);
								setFiltersBarOpen(true);
								setIsAddConditionView(true);
								setAddConditionRowIdx(savedRowIdx);
								setPreviousView(null);
							} else {
								setFilterView(null);
								setActiveRowIdx(null);
								setFiltersBarOpen(true);
							}
						}}
						setFilters={setFilters}
						filters={filters}
						property={''}
						propertyName={''}
						propertyNameSingular={''}
						logo={false}
						index={activeRowIdx}
						children={
							<div className="flex flex-col gap-4 p-4">
								<label className="text-lg font-semibold mb-2">Filter Name</label>
								<input
									className="p-2 rounded bg-gray-800 text-white border border-gray-600"
									type="text"
									value={filters[activeRowIdx]?.name || ''}
									onChange={async (e) => {
										// const newName = e.target.value;
										// const copy = JSON.parse(JSON.stringify(filters));
										// copy[activeRowIdx].name = newName;
										// setFilters(copy);
										// // Update userdb in localStorage
										// const userdb = JSON.parse(window.localStorage.getItem('userdb') || 'null');
										// const access_token = window.localStorage.getItem('access_token');
										// userdb?.queries = [copy]; // Only update the current query row
										// window.localStorage.setItem('userdb', JSON.stringify(userdb));
										// // Call rename_query2 endpoint
										// try {
										// 	await axios.get(`${process.env.REACT_APP_BACKEND_URL}/rename_query2?index=${activeRowIdx}&email=${userdb?.email}&new_name=${encodeURIComponent(newName)}`, {
										// 		headers: {
										// 			Authorization: `Bearer ${access_token}`,
										// 		},
										// 	});
										// } catch (err) {
										// 	// Optionally handle error
										// }
									}}
									placeholder="Enter filter name"
								/>
							</div>
						}
					/>
				)}
				{filterView === 'minMaxEv' && activeRowIdx !== null && (
					<MinMaxEVContent
						filters={filters}
						activeRowIdx={activeRowIdx}
						setFilters={setFilters}
						email={email}
						onClose={() => {
							if (previousView === 'addCondition') {
								const savedRowIdx = activeRowIdx;
								// Set isSpecificView to false FIRST, before other state updates
								if (setIsSpecificViewRef?.current) {
									setIsSpecificViewRef.current(false);
								}
								setFilterView(null);
								setActiveRowIdx(null);
								setFiltersBarOpen(true);
								setIsAddConditionView(true);
								setAddConditionRowIdx(savedRowIdx);
								setPreviousView(null);
							} else {
								setFilterView(null);
								setActiveRowIdx(null);
								setFiltersBarOpen(true);
							}
						}}
					/>
				)}
				{/* Old maxEv view - removed, now using minMaxEv */}
				{false && filterView === 'maxEv' && activeRowIdx !== null && (
					<FilterSidebar
						onClose={() => {
							if (previousView === 'addCondition') {
								const savedRowIdx = activeRowIdx;
								// Set isSpecificView to false FIRST, before other state updates
								if (setIsSpecificViewRef?.current) {
									setIsSpecificViewRef.current(false);
								}
							setFilterView(null);
							setActiveRowIdx(null);
								setFiltersBarOpen(true);
								setIsAddConditionView(true);
								setAddConditionRowIdx(savedRowIdx);
								setPreviousView(null);
							} else {
								setFilterView(null);
								setActiveRowIdx(null);
								setFiltersBarOpen(true);
							}
						}}
						setFilters={setFilters}
						filters={filters}
						property={''}
						propertyName={''}
						propertyNameSingular={''}
						logo={false}
						index={activeRowIdx}
						children={
							<div className="p-4">
								<EvPercentKeypad
									label="Maximum EV"
									value={filters[activeRowIdx]?.minMaxEv?.[1] === 9999999 ? 0 : filters[activeRowIdx]?.minMaxEv?.[1] || 0}
									onChange={async val => {
										const copy = JSON.parse(JSON.stringify(filters));
										copy[activeRowIdx].minMaxEv[1] = val;
										setFilters(copy);
										// Update only the currently selected query in userdb?.queries
										const userdb = JSON.parse(window.localStorage.getItem('userdb') || 'null');
										const selectedName = userdb?.selected_query || (userdb?.queries?.[0]?.[0]?.name ?? 'default');
										const idx = userdb?.queries.findIndex(q => q?.[0]?.name === selectedName);
										if (idx !== -1) {
											if (userdb?.queries) userdb.queries[idx] = copy;
											window.localStorage.setItem('userdb', JSON.stringify(userdb));
											await saveUserInfo(copy, email, false);
										}
									}}
									onClose={() => {
										if (previousView === 'addCondition') {
										setFilterView(null);
										setActiveRowIdx(null);
											setIsAddConditionView(true);
											setPreviousView(null);
										} else {
											setFilterView(null);
											setActiveRowIdx(null);
										}
									}}
								/>
							</div>
						}
					/>
				)}
				{filterView === 'minMaxOdds' && activeRowIdx !== null && (
					<MinMaxOddsContent
						filters={filters}
						activeRowIdx={activeRowIdx}
						setFilters={setFilters}
						email={email}
						onClose={() => {
							if (previousView === 'addCondition') {
								const savedRowIdx = activeRowIdx;
								// Set isSpecificView to false FIRST, before other state updates
								if (setIsSpecificViewRef?.current) {
									setIsSpecificViewRef.current(false);
								}
								setFilterView(null);
								setActiveRowIdx(null);
								setFiltersBarOpen(true);
								setIsAddConditionView(true);
								setAddConditionRowIdx(savedRowIdx);
								setPreviousView(null);
							} else {
								setFilterView(null);
								setActiveRowIdx(null);
								setFiltersBarOpen(true);
							}
						}}
					/>
				)}
				{/* Old minOdds and maxOdds views - removed, now using minMaxOdds */}
				{false && filterView === 'minOdds' && activeRowIdx !== null && (
					<FilterSidebar
						onClose={() => {
							if (previousView === 'addCondition') {
								const savedRowIdx = activeRowIdx;
								// Set isSpecificView to false FIRST, before other state updates
								if (setIsSpecificViewRef?.current) {
									setIsSpecificViewRef.current(false);
								}
							setFilterView(null);
							setActiveRowIdx(null);
								setFiltersBarOpen(true);
								setIsAddConditionView(true);
								setAddConditionRowIdx(savedRowIdx);
								setPreviousView(null);
							} else {
								setFilterView(null);
								setActiveRowIdx(null);
								setFiltersBarOpen(true);
							}
						}}
						setFilters={setFilters}
						filters={filters}
						property={''}
						propertyName={''}
						propertyNameSingular={''}
						logo={false}
						index={activeRowIdx}
						children={
							<div className="p-4">
								<OddsKeypad
									label="Minimum Odds"
									value={filters[activeRowIdx]?.minMaxOdds?.[0] === -9999999 ? 0 : filters[activeRowIdx]?.minMaxOdds?.[0] || 0}
									onChange={async val => {
										const copy = JSON.parse(JSON.stringify(filters));
										copy[activeRowIdx].minMaxOdds[0] = val;
										setFilters(copy);
										const userdb = JSON.parse(window.localStorage.getItem('userdb') || 'null');
										const selectedName = userdb?.selected_query || (userdb?.queries?.[0]?.[0]?.name ?? 'default');
										const idx = userdb?.queries.findIndex(q => q?.[0]?.name === selectedName);
										if (idx !== -1) {
											if (userdb?.queries) userdb.queries[idx] = copy;
											window.localStorage.setItem('userdb', JSON.stringify(userdb));
											await saveUserInfo(copy, email, false);
										}
									}}
									onClose={() => {
										if (previousView === 'addCondition') {
										setFilterView(null);
										setActiveRowIdx(null);
											setIsAddConditionView(true);
											setPreviousView(null);
										} else {
											setFilterView(null);
											setActiveRowIdx(null);
										}
									}}
								/>
							</div>
						}
					/>
				)}
				{false && filterView === 'maxOdds' && activeRowIdx !== null && (
					<FilterSidebar
						onClose={() => {
							if (previousView === 'addCondition') {
								const savedRowIdx = activeRowIdx;
								// Set isSpecificView to false FIRST, before other state updates
								if (setIsSpecificViewRef?.current) {
									setIsSpecificViewRef.current(false);
								}
							setFilterView(null);
							setActiveRowIdx(null);
								setFiltersBarOpen(true);
								setIsAddConditionView(true);
								setAddConditionRowIdx(savedRowIdx);
								setPreviousView(null);
							} else {
								setFilterView(null);
								setActiveRowIdx(null);
								setFiltersBarOpen(true);
							}
						}}
						setFilters={setFilters}
						filters={filters}
						property={''}
						propertyName={''}
						propertyNameSingular={''}
						logo={false}
						index={activeRowIdx}
						children={
							<div className="p-4">
								<OddsKeypad
									label="Maximum Odds"
									value={filters[activeRowIdx]?.minMaxOdds?.[1] === 9999999 ? 0 : filters[activeRowIdx]?.minMaxOdds?.[1] || 0}
									onChange={async val => {
										const copy = JSON.parse(JSON.stringify(filters));
										copy[activeRowIdx].minMaxOdds[1] = val;
										setFilters(copy);
										const userdb = JSON.parse(window.localStorage.getItem('userdb') || 'null');
										const selectedName = userdb?.selected_query || (userdb?.queries?.[0]?.[0]?.name ?? 'default');
										const idx = userdb?.queries.findIndex(q => q?.[0]?.name === selectedName);
										if (idx !== -1) {
											if (userdb?.queries) userdb.queries[idx] = copy;
											window.localStorage.setItem('userdb', JSON.stringify(userdb));
											await saveUserInfo(copy, email, false);
										}
									}}
									onClose={() => {
										setFilterView(null);
										setActiveRowIdx(null);
									}}
								/>
							</div>
						}
					/>
				)}
				{filterView === 'limit' && activeRowIdx !== null && (
					<LimitFilterContent
						filters={filters}
						activeRowIdx={activeRowIdx}
						setFilters={setFilters}
						email={email}
						onClose={() => {
							if (previousView === 'addCondition') {
							setFilterView(null);
							setActiveRowIdx(null);
								setIsAddConditionView(true);
								setPreviousView(null);
							} else {
										setFilterView(null);
										setActiveRowIdx(null);
							}
									}}
					/>
				)}
				{filterView === 'markets' && activeRowIdx !== null && (
					<FilterSidebar
						onClose={() => {
							if (previousView === 'addCondition') {
								const savedRowIdx = activeRowIdx;
								// Set isSpecificView to false FIRST, before other state updates
								if (setIsSpecificViewRef?.current) {
									setIsSpecificViewRef.current(false);
								}
							setFilterView(null);
							setActiveRowIdx(null);
								setFiltersBarOpen(true);
								setIsAddConditionView(true);
								setAddConditionRowIdx(savedRowIdx);
								setPreviousView(null);
							} else {
								setFilterView(null);
								setActiveRowIdx(null);
								setFiltersBarOpen(true);
							}
						}}
						setFilters={setFilters}
						filters={filters}
						options={MARKETS.map((m) => ({ label: m, value: m }))}
						property={'markets'}
						propertyName={'markets'}
						propertyNameSingular={'market'}
						logo={false}
						index={activeRowIdx}
					/>
				)}
				{filterView === 'marketTypes' && activeRowIdx !== null && (
					<FilterSidebar
						onClose={() => {
							if (previousView === 'addCondition') {
								const savedRowIdx = activeRowIdx;
								// Set isSpecificView to false FIRST, before other state updates
								if (setIsSpecificViewRef?.current) {
									setIsSpecificViewRef.current(false);
								}
							setFilterView(null);
							setActiveRowIdx(null);
								setFiltersBarOpen(true);
								setIsAddConditionView(true);
								setAddConditionRowIdx(savedRowIdx);
								setPreviousView(null);
							} else {
								setFilterView(null);
								setActiveRowIdx(null);
								setFiltersBarOpen(true);
							}
						}}
						setFilters={setFilters}
						filters={filters}
						options={[
							{ value: 'Main Markets', label: 'Main Markets' },
							{ value: 'Alternate Markets', label: 'Alternate Markets' },
							{ value: 'Player Props', label: 'Player Props' },
						]}
						property={'marketTypes'}
						propertyName={'market types'}
						propertyNameSingular={'market type'}
						logo={false}
						index={activeRowIdx}
					/>
				)}
				{/* Old minEv and maxEv views - removed, now using minMaxEv */}
				{false && filterView === 'minEv' && activeRowIdx !== null && (
					<FilterSidebar
						onClose={() => {
							if (previousView === 'addCondition') {
								const savedRowIdx = activeRowIdx;
								// Set isSpecificView to false FIRST, before other state updates
								if (setIsSpecificViewRef?.current) {
									setIsSpecificViewRef.current(false);
								}
							setFilterView(null);
							setActiveRowIdx(null);
								setFiltersBarOpen(true);
								setIsAddConditionView(true);
								setAddConditionRowIdx(savedRowIdx);
								setPreviousView(null);
							} else {
								setFilterView(null);
								setActiveRowIdx(null);
								setFiltersBarOpen(true);
							}
						}}
						setFilters={setFilters}
						filters={filters}
						property={''}
						propertyName={''}
						propertyNameSingular={''}
						logo={false}
						index={activeRowIdx}
						children={
							<div className="p-4">
								<EvPercentKeypad
									label="Minimum EV"
									value={filters[activeRowIdx]?.minMaxEv?.[0] === -9999999 ? 0 : filters[activeRowIdx]?.minMaxEv?.[0] || 0}
									onChange={async val => {
										const copy = JSON.parse(JSON.stringify(filters));
										copy[activeRowIdx].minMaxEv[0] = val;
										setFilters(copy);
										// Update only the currently selected query in userdb?.queries
										const userdb = JSON.parse(window.localStorage.getItem('userdb') || 'null');
										const selectedName = userdb?.selected_query || (userdb?.queries?.[0]?.[0]?.name ?? 'default');
										const idx = userdb?.queries.findIndex(q => q?.[0]?.name === selectedName);
										if (idx !== -1) {
											if (userdb?.queries) userdb.queries[idx] = copy;
											window.localStorage.setItem('userdb', JSON.stringify(userdb));
											await saveUserInfo(copy, email, false);
										}
									}}
									onClose={() => {
										if (previousView === 'addCondition') {
										setFilterView(null);
										setActiveRowIdx(null);
											setIsAddConditionView(true);
											setPreviousView(null);
										} else {
											setFilterView(null);
											setActiveRowIdx(null);
										}
									}}
								/>
							</div>
						}
					/>
				)}
				{false && filterView === 'maxEv' && activeRowIdx !== null && (
					<FilterSidebar
						onClose={() => {
							if (previousView === 'addCondition') {
								const savedRowIdx = activeRowIdx;
								// Set isSpecificView to false FIRST, before other state updates
								if (setIsSpecificViewRef?.current) {
									setIsSpecificViewRef.current(false);
								}
							setFilterView(null);
							setActiveRowIdx(null);
								setFiltersBarOpen(true);
								setIsAddConditionView(true);
								setAddConditionRowIdx(savedRowIdx);
								setPreviousView(null);
							} else {
								setFilterView(null);
								setActiveRowIdx(null);
								setFiltersBarOpen(true);
							}
						}}
						setFilters={setFilters}
						filters={filters}
						property={''}
						propertyName={''}
						propertyNameSingular={''}
						logo={false}
						index={activeRowIdx}
						children={
							<div className="p-4">
								<EvPercentKeypad
									label="Maximum EV"
									value={filters[activeRowIdx]?.minMaxEv?.[1] === 9999999 ? 0 : filters[activeRowIdx]?.minMaxEv?.[1] || 0}
									onChange={async val => {
										const copy = JSON.parse(JSON.stringify(filters));
										copy[activeRowIdx].minMaxEv[1] = val;
										setFilters(copy);
										// Update only the currently selected query in userdb?.queries
										const userdb = JSON.parse(window.localStorage.getItem('userdb') || 'null');
										const selectedName = userdb?.selected_query || (userdb?.queries?.[0]?.[0]?.name ?? 'default');
										const idx = userdb?.queries.findIndex(q => q?.[0]?.name === selectedName);
										if (idx !== -1) {
											if (userdb?.queries) userdb.queries[idx] = copy;
											window.localStorage.setItem('userdb', JSON.stringify(userdb));
											await saveUserInfo(copy, email, false);
										}
									}}
									onClose={() => {
										if (previousView === 'addCondition') {
										setFilterView(null);
										setActiveRowIdx(null);
											setIsAddConditionView(true);
											setPreviousView(null);
										} else {
											setFilterView(null);
											setActiveRowIdx(null);
										}
									}}
								/>
							</div>
						}
					/>
				)}
				{filterView === 'hide_alternates' && activeRowIdx !== null && (
					<HideAlternatesContent
						filters={filters}
						activeRowIdx={activeRowIdx}
						setFilters={setFilters}
						email={email}
						onClose={() => {
							if (previousView === 'addCondition') {
								const savedRowIdx = activeRowIdx;
								// Set isSpecificView to false FIRST, before other state updates
								if (setIsSpecificViewRef?.current) {
									setIsSpecificViewRef.current(false);
								}
							setFilterView(null);
							setActiveRowIdx(null);
								setFiltersBarOpen(true);
								setIsAddConditionView(true);
								setAddConditionRowIdx(savedRowIdx);
								setPreviousView(null);
							} else {
								setFilterView(null);
								setActiveRowIdx(null);
								setFiltersBarOpen(true);
							}
						}}
					/>
				)}
			</div>
		</div>
	);
};
